// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AddIgnoredUserData, addIgnoredUserErrors, AddIgnoredUserResponses, AddSubscriptionSubscriptionData, addSubscriptionSubscriptionErrors, AddSubscriptionSubscriptionResponses, AssociateUserWithTenantUserData, associateUserWithTenantUserErrors, AssociateUserWithTenantUserResponses, AuthenticateWithUsernameAndPasswordPrenlyData, authenticateWithUsernameAndPasswordPrenlyErrors, AuthenticateWithUsernameAndPasswordPrenlyResponses, AuthorPagesSitemapByDomainIdData, AuthorPagesSitemapByDomainIdResponses, AuthorPagesSitemapByPlatformData, AuthorPagesSitemapByPlatformResponses, BatchEventData, batchEventErrors, BatchEventResponses, ChangeEmailUserData, changeEmailUserErrors, ChangeEmailUserResponses, CheckBlockedDomainData, CheckBlockedDomainResponses, CheckBlockedIpData, checkBlockedIpErrors, CheckBlockedIpResponses, CreateAiPromptData, createAiPromptErrors, CreateAiPromptResponses, CreateBannerByDomainIdData, createBannerByDomainIdErrors, CreateBannerByDomainIdResponses, CreateBlockedDomainData, createBlockedDomainErrors, CreateBlockedDomainResponses, CreateBlockedIpData, createBlockedIpErrors, CreateBlockedIpResponses, CreateBookmakerData, createBookmakerErrors, CreateBookmakerResponses, CreateCommentByDomainIdData, createCommentByDomainIdErrors, CreateCommentByDomainIdResponses, CreateCommentByPlatformData, createCommentByPlatformErrors, CreateCommentByPlatformResponses, CreateCuratedMarketingItemData, createCuratedMarketingItemErrors, CreateCuratedMarketingItemResponses, CreateCuratedNewsItemData, createCuratedNewsItemErrors, CreateCuratedNewsItemResponses, CreateCurationData, createCurationErrors, CreateCurationResponses, CreateFaqCategoryData, createFaqCategoryErrors, CreateFaqCategoryResponses, CreateFaqData, createFaqErrors, CreateFaqResponses, CreateFlaggedCommentByDomainIdData, createFlaggedCommentByDomainIdErrors, CreateFlaggedCommentByDomainIdResponses, CreateFlaggedCommentByPlatformData, createFlaggedCommentByPlatformErrors, CreateFlaggedCommentByPlatformResponses, CreateForbiddenWordByDomainIdData, createForbiddenWordByDomainIdErrors, CreateForbiddenWordByDomainIdResponses, CreateGiftData, createGiftErrors, CreateGiftResponses, CreateLikeCommentByDomainIdData, createLikeCommentByDomainIdErrors, CreateLikeCommentByDomainIdResponses, CreateLikeCommentByPlatformData, createLikeCommentByPlatformErrors, CreateLikeCommentByPlatformResponses, CreateLokaliseData, CreateLokaliseResponses, CreateMatchTickerByDomainIdData, createMatchTickerByDomainIdErrors, CreateMatchTickerByDomainIdResponses, CreateModuleScheduleByDomainIdData, createModuleScheduleByDomainIdErrors, CreateModuleScheduleByDomainIdResponses, CreateModuleScheduleByPlatformLocaleData, createModuleScheduleByPlatformLocaleErrors, CreateModuleScheduleByPlatformLocaleResponses, CreateNavItemByDomainIdData, createNavItemByDomainIdErrors, CreateNavItemByDomainIdResponses, CreateNewsByDomainIdData, createNewsByDomainIdErrors, CreateNewsByDomainIdResponses, CreateNewsMarketingBlockByDomainIdData, createNewsMarketingBlockByDomainIdErrors, CreateNewsMarketingBlockByDomainIdResponses, CreateNotificationBarByDomainIdData, createNotificationBarByDomainIdErrors, CreateNotificationBarByDomainIdResponses, CreateNotificationBarByPlatformLocaleData, createNotificationBarByPlatformLocaleErrors, CreateNotificationBarByPlatformLocaleResponses, CreatePageData, createPageErrors, CreatePageResponses, CreatePollByDomainIdData, createPollByDomainIdErrors, CreatePollByDomainIdResponses, CreatePropositionData, createPropositionErrors, CreatePropositionResponses, CreateRedirectByDomainIdData, createRedirectByDomainIdErrors, CreateRedirectByDomainIdResponses, CreateRelationSubscriptionData, createRelationSubscriptionErrors, CreateRelationSubscriptionResponses, CreateSupertokensUsersHearstMigrationData, createSupertokensUsersHearstMigrationErrors, CreateSupertokensUsersHearstMigrationResponses, CreateSupertokensUsersViMigrationData, createSupertokensUsersViMigrationErrors, CreateSupertokensUsersViMigrationResponses, CreateTestEventData, createTestEventErrors, CreateTestEventResponses, CreateTierData, createTierErrors, CreateTierGroupData, createTierGroupErrors, CreateTierGroupResponses, CreateTierResponses, CreateUserGeneratedContentData, createUserGeneratedContentErrors, CreateUserGeneratedContentResponses, CreateUspData, createUspErrors, CreateUspResponses, CreateVideofeedByDomainIdData, createVideofeedByDomainIdErrors, CreateVideofeedByDomainIdResponses, DeleteAiPromptData, deleteAiPromptErrors, DeleteAiPromptResponses, DeleteAllMatchTickerByDomainIdData, deleteAllMatchTickerByDomainIdErrors, DeleteAllMatchTickerByDomainIdResponses, DeleteBannerByDomainIdData, deleteBannerByDomainIdErrors, DeleteBannerByDomainIdResponses, DeleteBlockedDomainData, deleteBlockedDomainErrors, DeleteBlockedDomainResponses, DeleteBlockedIpData, deleteBlockedIpErrors, DeleteBlockedIpResponses, DeleteBookmakerData, deleteBookmakerErrors, DeleteBookmakerResponses, DeleteByIdFaqCategoryData, deleteByIdFaqCategoryErrors, DeleteByIdFaqCategoryResponses, DeleteByIdFaqData, deleteByIdFaqErrors, DeleteByIdFaqResponses, DeleteByIdPropositionData, deleteByIdPropositionErrors, DeleteByIdPropositionResponses, DeleteByIdTierData, deleteByIdTierErrors, DeleteByIdTierResponses, DeleteByIduspData, deleteByIduspErrors, DeleteByIduspResponses, DeleteCommentByDomainIdData, deleteCommentByDomainIdErrors, DeleteCommentByDomainIdResponses, DeleteCommentByPlatformData, deleteCommentByPlatformErrors, DeleteCommentByPlatformResponses, DeleteCorruptedUsersAutoblogMigrationData, DeleteCorruptedUsersAutoblogMigrationResponses, DeleteCorruptedUsersViMigrationData, deleteCorruptedUsersViMigrationErrors, DeleteCorruptedUsersViMigrationResponses, DeleteCuratedMarketingItemData, deleteCuratedMarketingItemErrors, DeleteCuratedMarketingItemResponses, DeleteCuratedNewsItemData, deleteCuratedNewsItemErrors, DeleteCuratedNewsItemResponses, DeleteCurationData, deleteCurationErrors, DeleteCurationResponses, DeleteFlaggedCommentByDomainIdData, deleteFlaggedCommentByDomainIdErrors, DeleteFlaggedCommentByDomainIdResponses, DeleteFlaggedCommentByPlatformData, deleteFlaggedCommentByPlatformErrors, DeleteFlaggedCommentByPlatformResponses, DeleteForbiddenWordByDomainIdData, deleteForbiddenWordByDomainIdErrors, DeleteForbiddenWordByDomainIdResponses, DeleteGiftData, deleteGiftErrors, DeleteGiftResponses, DeleteIgnoredUserData, deleteIgnoredUserErrors, DeleteIgnoredUserResponses, DeleteLikeCommentByDomainIdData, deleteLikeCommentByDomainIdErrors, DeleteLikeCommentByDomainIdResponses, DeleteLikeCommentByPlatformData, deleteLikeCommentByPlatformErrors, DeleteLikeCommentByPlatformResponses, DeleteMatchTickerByDomainIdData, deleteMatchTickerByDomainIdErrors, DeleteMatchTickerByDomainIdResponses, DeleteModuleScheduleByDomainIdData, deleteModuleScheduleByDomainIdErrors, DeleteModuleScheduleByDomainIdResponses, DeleteModuleScheduleByPlatformLocaleData, deleteModuleScheduleByPlatformLocaleErrors, DeleteModuleScheduleByPlatformLocaleResponses, DeleteMultipleTagTabData, deleteMultipleTagTabErrors, DeleteMultipleTagTabResponses, DeleteNavItemByDomainIdData, deleteNavItemByDomainIdErrors, DeleteNavItemByDomainIdResponses, DeleteNewsBookmarkData, deleteNewsBookmarkErrors, DeleteNewsBookmarkResponses, DeleteNewsByDomainIdData, deleteNewsByDomainIdErrors, DeleteNewsByDomainIdResponses, DeleteNewsMarketingBlockByDomainIdData, deleteNewsMarketingBlockByDomainIdErrors, DeleteNewsMarketingBlockByDomainIdResponses, DeleteNotificationBarByDomainIdData, deleteNotificationBarByDomainIdErrors, DeleteNotificationBarByDomainIdResponses, DeleteNotificationBarByPlatformLocaleData, deleteNotificationBarByPlatformLocaleErrors, DeleteNotificationBarByPlatformLocaleResponses, DeleteOldMatchOddsData, deleteOldMatchOddsErrors, DeleteOldMatchOddsResponses, DeletePageData, deletePageErrors, DeletePageResponses, DeletePollByDomainIdData, deletePollByDomainIdErrors, DeletePollByDomainIdResponses, DeleteProfileUserData, deleteProfileUserErrors, DeleteProfileUserResponses, DeleteRedirectByDomainIdData, deleteRedirectByDomainIdErrors, DeleteRedirectByDomainIdResponses, DeleteSupertokensUsersNotLinkedToNextUserSecureData, deleteSupertokensUsersNotLinkedToNextUserSecureErrors, DeleteSupertokensUsersNotLinkedToNextUserSecureResponses, DeleteTagByDomainIdData, deleteTagByDomainIdErrors, DeleteTagByDomainIdResponses, DeleteTestTokenEventData, deleteTestTokenEventErrors, DeleteTestTokenEventResponses, DeleteTierGroupData, deleteTierGroupErrors, DeleteTierGroupResponses, DeleteUserData, deleteUserErrors, DeleteUserResponses, DisassociateUserFromTenantUserData, disassociateUserFromTenantUserErrors, DisassociateUserFromTenantUserResponses, DuplicateTierData, duplicateTierErrors, DuplicateTierGroupData, duplicateTierGroupErrors, DuplicateTierGroupResponses, DuplicateTierResponses, EmailExistsUserData, EmailExistsUserResponses, EmailOrUsernameExistsUserData, EmailOrUsernameExistsUserResponses, EmitMatchEventsOptaImportData, emitMatchEventsOptaImportErrors, EmitMatchEventsOptaImportResponses, ExportAffiliateLinksHearstMigrationData, exportAffiliateLinksHearstMigrationErrors, FetchAndStoreVideoIndexAutoblogMigrationData, FetchAndStoreVideoIndexAutoblogMigrationResponses, FetchAutoblogImagesAutoblogMigrationData, fetchAutoblogImagesAutoblogMigrationErrors, FetchAutoblogImagesAutoblogMigrationResponses, FileUploadFileUploadData, fileUploadFileUploadErrors, FileUploadFileUploadResponses, FlushAllCacheData, flushAllCacheErrors, FlushAllCacheResponses, GenerateMatchReportAiData, generateMatchReportAiErrors, GenerateMatchReportAiResponses, GenerateMatchReportsAiData, generateMatchReportsAiErrors, GenerateMatchReportsAiResponses, GenerateShortAndSearchableNewsByDomainIdData, generateShortAndSearchableNewsByDomainIdErrors, GenerateShortAndSearchableNewsByDomainIdResponses, GetAccessTokenPayloadSecureData, getAccessTokenPayloadSecureErrors, GetAccessTokenPayloadSecureResponses, GetAdminAccessInfoUserData, getAdminAccessInfoUserErrors, GetAdminAccessInfoUserResponses, GetAdsTxtByPlatformData, GetAdsTxtByPlatformResponses, GetAllBookmakerData, getAllBookmakerErrors, GetAllBookmakerResponses, GetAuthorByCustomSlugUserData, GetAuthorByCustomSlugUserResponses, GetBannerByDomainIdData, getBannerByDomainIdErrors, GetBannerByDomainIdResponses, GetByFunctionalityNewsCategoryByDomainIdData, GetByFunctionalityNewsCategoryByDomainIdResponses, GetByIdBookmakerData, getByIdBookmakerErrors, GetByIdBookmakerResponses, GetByIdFaqCategoryData, getByIdFaqCategoryErrors, GetByIdFaqCategoryResponses, GetByIdFaqData, getByIdFaqErrors, GetByIdFaqResponses, GetByIdGiftData, getByIdGiftErrors, GetByIdGiftResponses, GetByIdMatchData, GetByIdMatchResponses, GetByIdNewsByDomainIdData, GetByIdNewsByDomainIdResponses, GetByIdPlayerData, GetByIdPlayerResponses, GetByIdPropositionData, getByIdPropositionErrors, GetByIdPropositionResponses, GetByIdsMatchData, GetByIdsMatchResponses, GetByIdTeamData, GetByIdTeamResponses, GetByIdTierData, getByIdTierErrors, GetByIdTierGroupData, getByIdTierGroupErrors, GetByIdTierGroupResponses, GetByIdTierResponses, GetByIdUserData, getByIdUserErrors, GetByIdUserResponses, GetByIduspData, getByIduspErrors, GetByIduspResponses, GetByOriginalIdNewsByDomainIdData, GetByOriginalIdNewsByDomainIdResponses, GetByPathNewsByDomainIdData, GetByPathNewsByDomainIdResponses, GetByPathPageData, GetByPathPageResponses, GetBySlugMatchData, GetBySlugMatchResponses, GetBySlugNewsByDomainIdData, GetBySlugNewsByDomainIdResponses, GetBySlugNewsCategoryByDomainIdData, GetBySlugNewsCategoryByDomainIdResponses, GetBySlugTagByDomainIdData, GetBySlugTagByDomainIdResponses, GetBySlugTierGroupData, GetBySlugTierGroupResponses, GetCareerByIdPlayerData, GetCareerByIdPlayerResponses, GetCompetitionData, GetCompetitionMatchesExportOptaExportData, getCompetitionMatchesExportOptaExportErrors, GetCompetitionMatchesExportOptaExportResponses, GetCompetitionResponses, GetConfigByPlatformLocaleData, GetConfigByPlatformLocaleResponses, GetContextsPlatformByPlatformData, GetContextsPlatformByPlatformResponses, GetCuratedMarketingItemData, GetCuratedMarketingItemResponses, GetCuratedNewsItemData, GetCuratedNewsItemResponses, GetCurationData, GetCurationResponses, GetDepartmentsByEditionContactFormData, getDepartmentsByEditionContactFormErrors, GetDepartmentsByEditionContactFormResponses, GetDeprecatedMobileConfigData, GetDeprecatedMobileConfigResponses, GetExtraInfoUserData, getExtraInfoUserErrors, GetExtraInfoUserResponses, GetFeaturedCarouselByDomainIdData, GetFeaturedCarouselByDomainIdResponses, GetForbiddenWordByDomainIdData, GetForbiddenWordByDomainIdResponses, GetForCompetitionMatchData, GetForCompetitionMatchResponses, GetForSpecifiedDatesMatchData, GetForSpecifiedDatesMatchResponses, GetForTeamMatchData, GetForTeamMatchResponses, GetForThirdPartyUserData, getForThirdPartyUserErrors, GetForThirdPartyUserResponses, GetForTournamentMatchData, GetForTournamentMatchResponses, GetGeoBlockData, GetGeoBlockResponses, GetInfoSubscriptionData, getInfoSubscriptionErrors, GetInfoSubscriptionResponses, GetMatchDetailsBySlugMatchData, GetMatchDetailsBySlugMatchResponses, GetMatchDetailsMatchData, GetMatchDetailsMatchResponses, GetMatchesWithOddsMatchData, GetMatchesWithOddsMatchResponses, GetMatchNewsNewsByDomainIdData, GetMatchNewsNewsByDomainIdResponses, GetMemorySnapshotMonitoringData, getMemorySnapshotMonitoringErrors, GetMemorySnapshotMonitoringResponses, GetMemoryUsageMonitoringData, GetMemoryUsageMonitoringResponses, GetMobileConfigData, GetMobileConfigResponses, GetMonitoringData, GetMonitoringResponses, GetMostCommentedNewsByDomainIdData, GetMostCommentedNewsByDomainIdResponses, GetMostLikesCommentByDomainIdData, GetMostLikesCommentByDomainIdResponses, GetMostLikesCommentByPlatformData, GetMostLikesCommentByPlatformResponses, GetMostReadCrossEditionNewsByDomainIdData, GetMostReadCrossEditionNewsByDomainIdResponses, GetMostReadNewsByDomainIdData, GetMostReadNewsByDomainIdResponses, GetNationalMatchesExportOptaExportData, getNationalMatchesExportOptaExportErrors, GetNationalMatchesExportOptaExportResponses, GetNewsByDomainIdData, GetNewsByDomainIdResponses, GetNewsMarketingBlockByDomainIdData, GetNewsMarketingBlockByDomainIdResponses, GetOddsDossierByPlatformLocaleData, GetOddsDossierByPlatformLocaleResponses, GetOptaRatingsPlayerRatingData, getOptaRatingsPlayerRatingErrors, GetOptaRatingsPlayerRatingResponses, GetOriginalRedirectData, GetOriginalRedirectResponses, GetPageData, GetPageResponses, GetPassportByIdPlayerData, GetPassportByIdPlayerResponses, GetPaymentMethodsSubscriptionData, GetPaymentMethodsSubscriptionResponses, GetPlatformByPlatformData, GetPlatformByPlatformResponses, GetPollByIdPollByDomainIdData, GetPollByIdPollByDomainIdResponses, GetProfileByIdUserData, getProfileByIdUserErrors, GetProfileByIdUserResponses, GetRankingExportOptaExportData, getRankingExportOptaExportErrors, GetRankingExportOptaExportResponses, GetRatingExportOptaExportData, getRatingExportOptaExportErrors, GetRatingExportOptaExportResponses, GetRedirectByDomainIdData, getRedirectByDomainIdErrors, GetRedirectByDomainIdResponses, GetScheduleExportOptaExportData, getScheduleExportOptaExportErrors, GetScheduleExportOptaExportResponses, GetShirtsTeamData, getShirtsTeamErrors, GetShirtsTeamResponses, GetStandingsExportOptaExportData, getStandingsExportOptaExportErrors, GetStandingsExportOptaExportResponses, GetStatusData, GetStatusResponses, GetSubscriptionDetailsSubscriptionData, getSubscriptionDetailsSubscriptionErrors, GetSubscriptionDetailsSubscriptionResponses, GetTagTypesTagByDomainIdData, GetTagTypesTagByDomainIdResponses, GetTeamExportOptaExportData, GetTeamExportOptaExportResponses, GetTeamSelectionTeamData, GetTeamSelectionTeamResponses, GetTournamentRankingsTournamentData, GetTournamentRankingsTournamentResponses, GetTournamentRoundsTournamentData, getTournamentRoundsTournamentErrors, GetTournamentRoundsTournamentResponses, GetTournamentStandingsTournamentData, GetTournamentStandingsTournamentResponses, GetUnreadNotificationsCountNotificationByDomainIdData, getUnreadNotificationsCountNotificationByDomainIdErrors, GetUnreadNotificationsCountNotificationByDomainIdResponses, GetUnreadNotificationsCountNotificationByPlatformData, getUnreadNotificationsCountNotificationByPlatformErrors, GetUnreadNotificationsCountNotificationByPlatformResponses, GetUserPrenlyData, getUserPrenlyErrors, GetUserPrenlyResponses, GetUserTenantsUserData, getUserTenantsUserErrors, GetUserTenantsUserResponses, GetVideofeedConfigByDomainIdData, GetVideofeedConfigByDomainIdResponses, GetVotedAnswerIdPollByDomainIdData, GetVotedAnswerIdPollByDomainIdResponses, GoogleNewsSitemapByDomainIdData, GoogleNewsSitemapByDomainIdResponses, GoogleNewsSitemapByPlatformData, GoogleNewsSitemapByPlatformResponses, HubWebSubData, HubWebSubResponses, ImportAuthorsHearstMigrationData, importAuthorsHearstMigrationErrors, ImportAuthorsHearstMigrationResponses, ImportHearstArticlesHearstMigrationData, importHearstArticlesHearstMigrationErrors, ImportHearstArticlesHearstMigrationResponses, ImportMatchesOptaImportData, importMatchesOptaImportErrors, ImportMatchesOptaImportResponses, ImportOddsBetCityData, importOddsBetCityErrors, ImportOddsBetCityResponses, ImportOddsTotoData, importOddsTotoErrors, ImportOddsTotoResponses, ImportOddsUnibetData, importOddsUnibetErrors, ImportOddsUnibetResponses, ImportOriginalRedirectsAutoblogMigrationData, ImportOriginalRedirectsAutoblogMigrationResponses, ImportTeamsOptaImportData, importTeamsOptaImportErrors, ImportTeamsOptaImportResponses, ImportTournamentsOptaImportData, importTournamentsOptaImportErrors, ImportTournamentsOptaImportResponses, ImportUsersBatchViMigrationData, importUsersBatchViMigrationErrors, ImportUsersBatchViMigrationResponses, ImportUserViMigrationData, importUserViMigrationErrors, ImportUserViMigrationResponses, ImportViafouraCommentsViMigrationData, importViafouraCommentsViMigrationErrors, ImportViafouraCommentsViMigrationResponses, ImportViArticleViMigrationData, importViArticleViMigrationErrors, ImportViArticleViMigrationResponses, ImportViBookmarksViMigrationData, importViBookmarksViMigrationErrors, ImportViBookmarksViMigrationResponses, IncreaseVisitCountNewsByDomainIdData, IncreaseVisitCountNewsByDomainIdResponses, IndexSitemapByDomainIdData, IndexSitemapByDomainIdResponses, IndexSitemapByPlatformData, IndexSitemapByPlatformResponses, LatestMatchReportsAiData, LatestMatchReportsAiResponses, LinkAndSignInPasswordSecureData, linkAndSignInPasswordSecureErrors, LinkAndSignInPasswordSecureResponses, ListAiPromptData, listAiPromptErrors, ListAiPromptResponses, ListAuditLogByDomainIdData, listAuditLogByDomainIdErrors, ListAuditLogByDomainIdResponses, ListAuthorsUserData, ListAuthorsUserResponses, ListBlockedDomainData, listBlockedDomainErrors, ListBlockedDomainResponses, ListBlockedIpData, listBlockedIpErrors, ListBlockedIpResponses, ListCommentByDomainIdData, ListCommentByDomainIdResponses, ListCommentByPlatformData, ListCommentByPlatformResponses, ListExperimentByDomainIdData, listExperimentByDomainIdErrors, ListExperimentByDomainIdResponses, ListExternalSnippetData, ListExternalSnippetResponses, ListFaqCategoryData, listFaqCategoryErrors, ListFaqCategoryResponses, ListFaqData, ListFaqResponses, ListFeatureFlagData, ListFeatureFlagResponses, ListFilteredCommentByDomainIdData, listFilteredCommentByDomainIdErrors, ListFilteredCommentByDomainIdResponses, ListFlaggedCommentByDomainIdData, listFlaggedCommentByDomainIdErrors, ListFlaggedCommentByDomainIdResponses, ListFlaggedCommentByPlatformData, listFlaggedCommentByPlatformErrors, ListFlaggedCommentByPlatformResponses, ListForbiddenWordByDomainIdData, listForbiddenWordByDomainIdErrors, ListForbiddenWordByDomainIdResponses, ListGiftsGiftData, ListGiftsGiftResponses, ListGroupedByPlacementExternalSnippetData, ListGroupedByPlacementExternalSnippetResponses, ListIdsNewsBookmarkData, listIdsNewsBookmarkErrors, ListIdsNewsBookmarkResponses, ListIgnoredUserData, listIgnoredUserErrors, ListIgnoredUserResponses, ListLikeCommentByDomainIdData, listLikeCommentByDomainIdErrors, ListLikeCommentByDomainIdResponses, ListLikeCommentByPlatformData, listLikeCommentByPlatformErrors, ListLikeCommentByPlatformResponses, ListLocaleByLocaleData, listLocaleByLocaleErrors, ListLocaleByLocaleResponses, ListMatchOddsData, ListMatchOddsResponses, ListMatchTickerByDomainIdData, ListMatchTickerByDomainIdResponses, ListMenuData, listMenuErrors, ListMenuResponses, ListModuleScheduleByDomainIdData, ListModuleScheduleByDomainIdResponses, ListModuleScheduleByPlatformLocaleData, ListModuleScheduleByPlatformLocaleResponses, ListNavItemByDomainIdData, ListNavItemByDomainIdResponses, ListNewsBookmarkData, listNewsBookmarkErrors, ListNewsBookmarkResponses, ListNewsByDomainIdData, ListNewsByDomainIdResponses, ListNewsCategoryByDomainIdData, ListNewsCategoryByDomainIdResponses, ListNotificationBarByDomainIdData, ListNotificationBarByDomainIdResponses, ListNotificationBarByPlatformLocaleData, ListNotificationBarByPlatformLocaleResponses, ListNotificationByDomainIdData, listNotificationByDomainIdErrors, ListNotificationByDomainIdResponses, ListNotificationByPlatformData, listNotificationByPlatformErrors, ListNotificationByPlatformResponses, ListPageData, listPageErrors, ListPageResponses, ListPlayerRatingData, listPlayerRatingErrors, ListPlayerRatingResponses, ListPollByDomainIdData, ListPollByDomainIdResponses, ListRedirectByDomainIdData, ListRedirectByDomainIdResponses, ListResultsAiData, listResultsAiErrors, ListResultsAiResponses, ListSubscriptionData, listSubscriptionErrors, ListSubscriptionResponses, ListTabsTagTemplateData, listTabsTagTemplateErrors, ListTabsTagTemplateResponses, ListTagByDomainIdData, ListTagByDomainIdResponses, ListTagTabData, ListTagTabResponses, ListTagTemplateData, listTagTemplateErrors, ListTagTemplateResponses, ListTierData, ListTierGroupData, listTierGroupErrors, ListTierGroupResponses, ListTierResponses, ListUserData, listUserErrors, ListUserResponses, ListVideofeedByDomainIdData, ListVideofeedByDomainIdResponses, LogEventData, LogEventResponses, LookupAddressSubscriptionData, lookupAddressSubscriptionErrors, LookupAddressSubscriptionResponses, MarkAllAsReadNotificationByDomainIdData, markAllAsReadNotificationByDomainIdErrors, MarkAllAsReadNotificationByDomainIdResponses, MarkAllAsReadNotificationByPlatformData, markAllAsReadNotificationByPlatformErrors, MarkAllAsReadNotificationByPlatformResponses, MarkAsReadNotificationByDomainIdData, markAsReadNotificationByDomainIdErrors, MarkAsReadNotificationByDomainIdResponses, MarkAsReadNotificationByPlatformData, markAsReadNotificationByPlatformErrors, MarkAsReadNotificationByPlatformResponses, MarkSelectedAsReadNotificationByDomainIdData, markSelectedAsReadNotificationByDomainIdErrors, MarkSelectedAsReadNotificationByDomainIdResponses, MarkSelectedAsReadNotificationByPlatformData, markSelectedAsReadNotificationByPlatformErrors, MarkSelectedAsReadNotificationByPlatformResponses, MatchReportsAiData, matchReportsAiErrors, MatchReportsAiResponses, MergeOptaTagsViMigrationData, mergeOptaTagsViMigrationErrors, MigrateArticleAutoblogMigrationData, MigrateArticleAutoblogMigrationResponses, MigrateArticlesAutoblogMigrationData, MigrateArticlesAutoblogMigrationResponses, MigrateCarTagsAutoblogMigrationData, MigrateCarTagsAutoblogMigrationResponses, MigrateImagesOfSpotAutoblogMigrationData, MigrateImagesOfSpotAutoblogMigrationResponses, MigratePostTermsAutoblogMigrationData, MigratePostTermsAutoblogMigrationResponses, MigrateSpotAutoblogMigrationData, MigrateSpotAutoblogMigrationResponses, MigrateSpotImagesAutoblogMigrationData, migrateSpotImagesAutoblogMigrationErrors, MigrateSpotImagesAutoblogMigrationResponses, MigrateSpotsAutoblogMigrationData, migrateSpotsAutoblogMigrationErrors, MigrateSpotsAutoblogMigrationResponses, MigrateUserAutoblogMigrationData, migrateUserAutoblogMigrationErrors, MigrateUsersAutoblogMigrationData, migrateUsersAutoblogMigrationErrors, MigrateUsersAutoblogMigrationResponses, NavigationSitemapByDomainIdData, NavigationSitemapByDomainIdResponses, NavigationSitemapByPlatformData, NavigationSitemapByPlatformResponses, NewsSitemapByDomainIdData, NewsSitemapByDomainIdResponses, NewsSitemapByPlatformData, NewsSitemapByPlatformResponses, NextViMigrationData, nextViMigrationErrors, NextViMigrationResponses, PatchBookmakerData, patchBookmakerErrors, PatchBookmakerResponses, PatchCommentByDomainIdData, patchCommentByDomainIdErrors, PatchCommentByDomainIdResponses, PatchCommentByPlatformData, patchCommentByPlatformErrors, PatchCommentByPlatformResponses, PatchCuratedMatchData, patchCuratedMatchErrors, PatchCuratedMatchResponses, PatchFaqCategoryData, patchFaqCategoryErrors, PatchFaqCategoryResponses, PatchFaqData, patchFaqErrors, PatchFaqResponses, PatchGiftData, patchGiftErrors, PatchGiftResponses, PatchMatchTickerByDomainIdData, patchMatchTickerByDomainIdErrors, PatchMatchTickerByDomainIdResponses, PatchModuleScheduleByDomainIdData, patchModuleScheduleByDomainIdErrors, PatchModuleScheduleByDomainIdResponses, PatchModuleScheduleByPlatformLocaleData, patchModuleScheduleByPlatformLocaleErrors, PatchModuleScheduleByPlatformLocaleResponses, PatchMultipleTagTabData, patchMultipleTagTabErrors, PatchMultipleTagTabResponses, PatchNavItemByDomainIdData, patchNavItemByDomainIdErrors, PatchNavItemByDomainIdResponses, PatchNewsByDomainIdData, patchNewsByDomainIdErrors, PatchNewsByDomainIdResponses, PatchNewsCategoryByDomainIdData, patchNewsCategoryByDomainIdErrors, PatchNewsCategoryByDomainIdResponses, PatchNewsMarketingBlockByDomainIdData, patchNewsMarketingBlockByDomainIdErrors, PatchNewsMarketingBlockByDomainIdResponses, PatchNotificationBarByDomainIdData, patchNotificationBarByDomainIdErrors, PatchNotificationBarByDomainIdResponses, PatchNotificationBarByPlatformLocaleData, patchNotificationBarByPlatformLocaleErrors, PatchNotificationBarByPlatformLocaleResponses, PatchPageData, patchPageErrors, PatchPageResponses, PatchPlayerRatingData, patchPlayerRatingErrors, PatchPlayerRatingResponses, PatchPollByDomainIdData, patchPollByDomainIdErrors, PatchPollByDomainIdResponses, PatchProfileUserData, patchProfileUserErrors, PatchProfileUserResponses, PatchPropositionData, patchPropositionErrors, PatchPropositionResponses, PatchTierData, patchTierErrors, PatchTierGroupData, patchTierGroupErrors, PatchTierGroupResponses, PatchTierResponses, PatchUserData, patchUserErrors, PatchUserResponses, PatchVideofeedByDomainIdData, patchVideofeedByDomainIdErrors, PatchVideofeedByDomainIdResponses, PathHasTagNewsByDomainIdData, PathHasTagNewsByDomainIdResponses, PaymentSucceededSubscriptionData, paymentSucceededSubscriptionErrors, PaymentSucceededSubscriptionResponses, PostNewsBookmarkData, postNewsBookmarkErrors, PostNewsBookmarkResponses, PrepareViafouraCommentsViMigrationData, prepareViafouraCommentsViMigrationErrors, PrepareViafouraCommentsViMigrationResponses, ProcessImageBlockFileUploadData, processImageBlockFileUploadErrors, ProcessImageBlockFileUploadResponses, PublishIfNeededWebSubData, publishIfNeededWebSubErrors, PublishIfNeededWebSubResponses, PutMobileConfigData, putMobileConfigErrors, PutMobileConfigResponses, PutRedirectByDomainIdData, putRedirectByDomainIdErrors, PutRedirectByDomainIdResponses, RedirectsSubscriptionData, RedirectsSubscriptionResponses, ReformatListicleBlocksHearstMigrationData, reformatListicleBlocksHearstMigrationErrors, ReformatListicleBlocksHearstMigrationResponses, RenewZenoStatusUserData, renewZenoStatusUserErrors, RenewZenoStatusUserResponses, ReplaceAffiliateLinksHearstMigrationData, replaceAffiliateLinksHearstMigrationErrors, ReplaceAffiliateLinksHearstMigrationResponses, ReplaceLinksAutoblogMigrationData, ReplaceLinksAutoblogMigrationResponses, ReplaceLinksHearstMigrationData, replaceLinksHearstMigrationErrors, ReplaceLinksHearstMigrationResponses, ReplaceLinksViMigrationData, replaceLinksViMigrationErrors, ReplaceLinksViMigrationResponses, ReplaceTabLinksAutoblogMigrationData, ReplaceTabLinksAutoblogMigrationResponses, RequestPaymentLinkSubscriptionData, requestPaymentLinkSubscriptionErrors, RequestPaymentLinkSubscriptionResponses, RescheduleCurationData, rescheduleCurationErrors, RescheduleCurationResponses, ResetPasswordSecureData, resetPasswordSecureErrors, ResetPasswordSecureResponses, ScheduleAllViMigrationData, scheduleAllViMigrationErrors, ScheduleAllViMigrationResponses, ScheduleRecentViMigrationData, scheduleRecentViMigrationErrors, ScheduleRecentViMigrationResponses, SearchMatchData, searchMatchErrors, SearchMatchResponses, SendContactFormContactFormData, SendContactFormContactFormResponses, SendPasswordResetEmailSecureData, sendPasswordResetEmailSecureErrors, SendPasswordResetEmailSecureResponses, SendPushNotificationsNewsByDomainIdData, sendPushNotificationsNewsByDomainIdErrors, SendPushNotificationsNewsByDomainIdResponses, SendVerificationEmailSecureData, SendVerificationEmailSecureResponses, SetGeneratedPasswordUserData, setGeneratedPasswordUserErrors, SetGeneratedPasswordUserResponses, SetTestTokenEventData, setTestTokenEventErrors, SetTestTokenEventResponses, ShouldSwitchSubscriptionData, shouldSwitchSubscriptionErrors, ShouldSwitchSubscriptionResponses, SignInPasswordSecureData, signInPasswordSecureErrors, SignInPasswordSecureResponses, SignUpPasswordSecureData, signUpPasswordSecureErrors, SignUpPasswordSecureResponses, SyncDisassociateUserData, syncDisassociateUserErrors, SyncDisassociateUserResponses, SyncKambiData, syncKambiErrors, SyncKambiResponses, SyncStagingSupertokensUsersUserData, syncStagingSupertokensUsersUserErrors, SyncTotoData, syncTotoErrors, SyncTotoResponses, TagsSitemapByDomainIdData, TagsSitemapByDomainIdResponses, TagsSitemapByPlatformData, TagsSitemapByPlatformResponses, UpdateAiPromptData, updateAiPromptErrors, UpdateAiPromptResponses, UpdateBannerByDomainIdData, updateBannerByDomainIdErrors, UpdateBannerByDomainIdResponses, UpdateCuratedMarketingItemData, updateCuratedMarketingItemErrors, UpdateCuratedMarketingItemResponses, UpdateCuratedNewsItemData, updateCuratedNewsItemErrors, UpdateCuratedNewsItemResponses, UpdateCurationData, updateCurationErrors, UpdateCurationResponses, UpdateExternalSnippetData, updateExternalSnippetErrors, UpdateExternalSnippetResponses, UpdateForbiddenWordByDomainIdData, updateForbiddenWordByDomainIdErrors, UpdateForbiddenWordByDomainIdResponses, UpdateMultipleCommentByDomainIdData, updateMultipleCommentByDomainIdErrors, UpdateMultipleCommentByDomainIdResponses, UpdateMultipleCommentByPlatformData, updateMultipleCommentByPlatformErrors, UpdateMultipleCommentByPlatformResponses, UpdatePasswordSecureData, updatePasswordSecureErrors, UpdatePasswordSecureResponses, UpdatePlayerTagsOptaImportData, updatePlayerTagsOptaImportErrors, UpdatePlayerTagsOptaImportResponses, UpdateRelationAddressSubscriptionData, updateRelationAddressSubscriptionErrors, UpdateRelationAddressSubscriptionResponses, UpdateUserSubscriptionData, updateUserSubscriptionErrors, UpdateUserSubscriptionResponses, UpdateUspData, updateUspErrors, UpdateUspResponses, UpsertAdsTxtByPlatformData, upsertAdsTxtByPlatformErrors, UpsertAdsTxtByPlatformResponses, UpsertConfigByPlatformLocaleData, upsertConfigByPlatformLocaleErrors, UpsertConfigByPlatformLocaleResponses, UpsertOddsDossierByPlatformLocaleData, upsertOddsDossierByPlatformLocaleErrors, UpsertOddsDossierByPlatformLocaleResponses, UpsertVideofeedConfigByDomainIdData, upsertVideofeedConfigByDomainIdErrors, UpsertVideofeedConfigByDomainIdResponses, UsernameExistsUserData, UsernameExistsUserResponses, VerifyChangedEmailSecureData, verifyChangedEmailSecureErrors, VerifyChangedEmailSecureResponses, VerifyEmailSecureData, verifyEmailSecureErrors, VerifyEmailSecureResponses, VoteBinaryPollByDomainIdData, VoteBinaryPollByDomainIdResponses, VotePollByDomainIdData, VotePollByDomainIdResponses, WarmUpCacheWebpByPlatformData, warmUpCacheWebpByPlatformErrors, XPostEmbedEmbedHtmlData, xPostEmbedEmbedHtmlErrors, XPostEmbedEmbedHtmlResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class AutoblogMigrationService {
    public static migrateArticlesAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateArticlesAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigrateArticlesAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/article', ...options });
    }
    
    /**
     * Migrate an article from Autoblog
     */
    public static migrateArticleAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateArticleAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigrateArticleAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/article/{id}', ...options });
    }
    
    /**
     * Migrate a spot from Autoblog by original postID
     */
    public static migrateSpotAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateSpotAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigrateSpotAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/spot/{id}', ...options });
    }
    
    /**
     * Migrate a batch of Autoblog spots.
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 30000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static migrateSpotsAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateSpotsAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigrateSpotsAutoblogMigrationResponses, migrateSpotsAutoblogMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/autoblog-migration/spot',
            ...options
        });
    }
    
    /**
     * Migrate the images of one spot.
     */
    public static migrateImagesOfSpotAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateImagesOfSpotAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigrateImagesOfSpotAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/spot/{id}/image', ...options });
    }
    
    /**
     * Migrate the images of all spots.
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 60000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static migrateSpotImagesAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateSpotImagesAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigrateSpotImagesAutoblogMigrationResponses, migrateSpotImagesAutoblogMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/autoblog-migration/spot-image',
            ...options
        });
    }
    
    /**
     * Replace links in articles with the new links.
     */
    public static replaceLinksAutoblogMigration<ThrowOnError extends boolean = false>(options?: Options<ReplaceLinksAutoblogMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ReplaceLinksAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/replace-links', ...options });
    }
    
    /**
     * Replace links in tabs with the new links.
     */
    public static replaceTabLinksAutoblogMigration<ThrowOnError extends boolean = false>(options?: Options<ReplaceTabLinksAutoblogMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ReplaceTabLinksAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/replace-tab-links', ...options });
    }
    
    /**
     * Migrate the images of x autoblog articles.
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 60000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static fetchAutoblogImagesAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<FetchAutoblogImagesAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<FetchAutoblogImagesAutoblogMigrationResponses, fetchAutoblogImagesAutoblogMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/autoblog-migration/image',
            ...options
        });
    }
    
    /**
     * Migrate a user from Autoblog
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 60000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     */
    public static migrateUserAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateUserAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<unknown, migrateUserAutoblogMigrationErrors, ThrowOnError>({ url: '/autoblog-migration/user/{id}', ...options });
    }
    
    /**
     * Migrate multiple users from Autoblog
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 60000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static migrateUsersAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigrateUsersAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigrateUsersAutoblogMigrationResponses, migrateUsersAutoblogMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/autoblog-migration/users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * ONLY RUN THIS ENDPOINT AFTER YOU'RE DONE WITH THE USER IMPORT.
     *
     * Go through the abUserMigration entries with status != 'completed'. For every entry, if the Next user doesn't exist but the Supertokens user does exist, then delete the Supertokens user. Also, if the Next user doesn't exist, delete the entry from the abUserMigration table, regardless of whether the Supertokens user exists.
     */
    public static deleteCorruptedUsersAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<DeleteCorruptedUsersAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCorruptedUsersAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/delete-corrupted-users', ...options });
    }
    
    /**
     * Migrate the car brand and car model tags from Autoblog.
     */
    public static migrateCarTagsAutoblogMigration<ThrowOnError extends boolean = false>(options?: Options<MigrateCarTagsAutoblogMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<MigrateCarTagsAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/car-tags', ...options });
    }
    
    /**
     * Migrate the terms from Autoblog as tags.
     */
    public static migratePostTermsAutoblogMigration<ThrowOnError extends boolean = false>(options: Options<MigratePostTermsAutoblogMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<MigratePostTermsAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/terms', ...options });
    }
    
    /**
     * Fetch and store the mapping between video IDs and their URLs from Blue Billywig.
     */
    public static fetchAndStoreVideoIndexAutoblogMigration<ThrowOnError extends boolean = false>(options?: Options<FetchAndStoreVideoIndexAutoblogMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<FetchAndStoreVideoIndexAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/video-index', ...options });
    }
    
    /**
     * Import data from abMigrationList into the originalRedirect table.
     */
    public static importOriginalRedirectsAutoblogMigration<ThrowOnError extends boolean = false>(options?: Options<ImportOriginalRedirectsAutoblogMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportOriginalRedirectsAutoblogMigrationResponses, unknown, ThrowOnError>({ url: '/autoblog-migration/original-redirect', ...options });
    }
}

export class BetCityService {
    /**
     * - Allowed roles: app_cron
     */
    public static importOddsBetCity<ThrowOnError extends boolean = false>(options?: Options<ImportOddsBetCityData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportOddsBetCityResponses, importOddsBetCityErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/betcity/import/odds',
            ...options
        });
    }
}

export class BlockedDomainService {
    /**
     * Get all blocked domains
     *
     * Return a list of blocked domains
     *
     * - Allowed roles: editor, admin
     */
    public static listBlockedDomain<ThrowOnError extends boolean = false>(options?: Options<ListBlockedDomainData, ThrowOnError>) {
        return (options?.client ?? client).get<ListBlockedDomainResponses, listBlockedDomainErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/blocked-domain',
            ...options
        });
    }
    
    /**
     * Add new blocked domain
     *
     * Create a new blocked domain
     *
     * - Allowed roles: editor, admin
     */
    public static createBlockedDomain<ThrowOnError extends boolean = false>(options: Options<CreateBlockedDomainData, ThrowOnError>) {
        return (options.client ?? client).post<CreateBlockedDomainResponses, createBlockedDomainErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/blocked-domain',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Check if domain is blocked
     */
    public static checkBlockedDomain<ThrowOnError extends boolean = false>(options: Options<CheckBlockedDomainData, ThrowOnError>) {
        return (options.client ?? client).get<CheckBlockedDomainResponses, unknown, ThrowOnError>({ url: '/blocked-domain/check', ...options });
    }
    
    /**
     * Delete a blocked domain
     *
     * - Allowed roles: editor, admin
     */
    public static deleteBlockedDomain<ThrowOnError extends boolean = false>(options: Options<DeleteBlockedDomainData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteBlockedDomainResponses, deleteBlockedDomainErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/blocked-domain/{id}',
            ...options
        });
    }
}

export class BlockedIpService {
    /**
     * Get all blocked ips
     *
     * Get a list of all blocked ip-addresses
     *
     * - Allowed roles: admin
     */
    public static listBlockedIp<ThrowOnError extends boolean = false>(options?: Options<ListBlockedIpData, ThrowOnError>) {
        return (options?.client ?? client).get<ListBlockedIpResponses, listBlockedIpErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/blocked-ip',
            ...options
        });
    }
    
    /**
     * Create blocked ip
     *
     * Create a new blocked ip address
     *
     * - Allowed roles: admin
     */
    public static createBlockedIp<ThrowOnError extends boolean = false>(options: Options<CreateBlockedIpData, ThrowOnError>) {
        return (options.client ?? client).post<CreateBlockedIpResponses, createBlockedIpErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/blocked-ip',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete blocked ip
     *
     * Delete a blocked ip address
     *
     * - Allowed roles: admin
     */
    public static deleteBlockedIp<ThrowOnError extends boolean = false>(options: Options<DeleteBlockedIpData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteBlockedIpResponses, deleteBlockedIpErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/blocked-ip/{ip}',
            ...options
        });
    }
    
    /**
     * Get blocked ip
     *
     * Fetch a specific IP
     */
    public static checkBlockedIp<ThrowOnError extends boolean = false>(options: Options<CheckBlockedIpData, ThrowOnError>) {
        return (options.client ?? client).get<CheckBlockedIpResponses, checkBlockedIpErrors, ThrowOnError>({ url: '/blocked-ip/{ip}', ...options });
    }
}

export class BookmakerService {
    /**
     * Get all bookmakers.
     *
     * Get all bookmakers.
     *
     * - Allowed roles: editor, admin
     */
    public static getAllBookmaker<ThrowOnError extends boolean = false>(options?: Options<GetAllBookmakerData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAllBookmakerResponses, getAllBookmakerErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/bookmaker',
            ...options
        });
    }
    
    /**
     * Create bookmaker.
     *
     * Create bookmaker.
     */
    public static createBookmaker<ThrowOnError extends boolean = false>(options: Options<CreateBookmakerData, ThrowOnError>) {
        return (options.client ?? client).post<CreateBookmakerResponses, createBookmakerErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/bookmaker',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete bookmaker.
     *
     * Delete bookmaker.
     */
    public static deleteBookmaker<ThrowOnError extends boolean = false>(options: Options<DeleteBookmakerData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteBookmakerResponses, deleteBookmakerErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/bookmaker/{id}',
            ...options
        });
    }
    
    /**
     * Get bookmaker.
     *
     * Get bookmaker.
     *
     * - Allowed roles: editor, admin
     */
    public static getByIdBookmaker<ThrowOnError extends boolean = false>(options: Options<GetByIdBookmakerData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdBookmakerResponses, getByIdBookmakerErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/bookmaker/{id}',
            ...options
        });
    }
    
    /**
     * Update bookmaker.
     *
     * Update bookmaker.
     */
    public static patchBookmaker<ThrowOnError extends boolean = false>(options: Options<PatchBookmakerData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchBookmakerResponses, patchBookmakerErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/bookmaker/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CacheService {
    /**
     * Flush all redis cache.
     *
     * - Allowed roles: admin
     */
    public static flushAllCache<ThrowOnError extends boolean = false>(options?: Options<FlushAllCacheData, ThrowOnError>) {
        return (options?.client ?? client).get<FlushAllCacheResponses, flushAllCacheErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/cache/flush-all',
            ...options
        });
    }
}

export class BannerService {
    /**
     * Get banners by contextID
     *
     * Return a list of banners for a given contextID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getBannerByDomainId<ThrowOnError extends boolean = false>(options: Options<GetBannerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetBannerByDomainIdResponses, getBannerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/banner',
            ...options
        });
    }
    
    /**
     * Create a new banner
     *
     * Creates and returns a new banner
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createBannerByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateBannerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateBannerByDomainIdResponses, createBannerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/banner',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing banner
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteBannerByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteBannerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteBannerByDomainIdResponses, deleteBannerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/banner/{bannerID}',
            ...options
        });
    }
    
    /**
     * Update an existing banner
     *
     * Updates and returns the edited banner
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static updateBannerByDomainId<ThrowOnError extends boolean = false>(options: Options<UpdateBannerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).put<UpdateBannerByDomainIdResponses, updateBannerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/banner/{bannerID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class BinaryPollService {
    /**
     * Vote yes/up/like/believe or no/down/dislike/disbelieve on an article
     *
     * Vote yes/up/like/believe or no/down/dislike/disbelieve on an article based on IP
     */
    public static voteBinaryPollByDomainId<ThrowOnError extends boolean = false>(options: Options<VoteBinaryPollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<VoteBinaryPollByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/binary-poll/{newsID}/vote/{direction}', ...options });
    }
}

export class CommentService {
    /**
     * Get all comments
     *
     * Return a list of comments for a given contextID.
     */
    public static listCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<ListCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListCommentByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/comment', ...options });
    }
    
    /**
     * Perform an update action on the list of comments
     *
     * Update multiple comments
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static updateMultipleCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<UpdateMultipleCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateMultipleCommentByDomainIdResponses, updateMultipleCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a comment
     *
     * Create a single comment and respond with the newly created item.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCommentByDomainIdResponses, createCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get most liked comments
     *
     * Return a list of most liked comments for a given contextID
     */
    public static getMostLikesCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<GetMostLikesCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetMostLikesCommentByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/comment/most-likes', ...options });
    }
    
    /**
     * Delete a comment
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCommentByDomainIdResponses, deleteCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/{id}',
            ...options
        });
    }
    
    /**
     * Patch a comment
     *
     * Patch a single comment
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static patchCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchCommentByDomainIdResponses, patchCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get all comments
     *
     * Return a list of comments for a given contextID.
     */
    public static listCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<ListCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<ListCommentByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/comment', ...options });
    }
    
    /**
     * Perform an update action on the list of comments
     *
     * Update multiple comments
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static updateMultipleCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<UpdateMultipleCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateMultipleCommentByPlatformResponses, updateMultipleCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a comment
     *
     * Create a single comment and respond with the newly created item.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<CreateCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCommentByPlatformResponses, createCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get most liked comments
     *
     * Return a list of most liked comments for a given contextID
     */
    public static getMostLikesCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<GetMostLikesCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<GetMostLikesCommentByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/comment/most-likes', ...options });
    }
    
    /**
     * Delete a comment
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<DeleteCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCommentByPlatformResponses, deleteCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/{id}',
            ...options
        });
    }
    
    /**
     * Patch a comment
     *
     * Patch a single comment
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static patchCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<PatchCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchCommentByPlatformResponses, patchCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class FlaggedCommentService {
    /**
     * Get a list of flagged commentIDs for a user on a news article.
     *
     * Return a list of flagged commentIDs, filtered by the authenticated user and a newsID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listFlaggedCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<ListFlaggedCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListFlaggedCommentByDomainIdResponses, listFlaggedCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/flag',
            ...options
        });
    }
    
    /**
     * Delete a flagged comment by commentID
     *
     * Delete a flagged comment by commentID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteFlaggedCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteFlaggedCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteFlaggedCommentByDomainIdResponses, deleteFlaggedCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/{commentID}/flag',
            ...options
        });
    }
    
    /**
     * Flag a comment by commentID
     *
     * Flag a comment by commentID. Returns new flagged comment serialized by public scope.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createFlaggedCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateFlaggedCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateFlaggedCommentByDomainIdResponses, createFlaggedCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/{commentID}/flag',
            ...options
        });
    }
    
    /**
     * Get a list of flagged commentIDs for a user on a news article.
     *
     * Return a list of flagged commentIDs, filtered by the authenticated user and a newsID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listFlaggedCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<ListFlaggedCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<ListFlaggedCommentByPlatformResponses, listFlaggedCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/flag',
            ...options
        });
    }
    
    /**
     * Delete a flagged comment by commentID
     *
     * Delete a flagged comment by commentID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteFlaggedCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<DeleteFlaggedCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteFlaggedCommentByPlatformResponses, deleteFlaggedCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/{commentID}/flag',
            ...options
        });
    }
    
    /**
     * Flag a comment by commentID
     *
     * Flag a comment by commentID. Returns new flagged comment serialized by public scope.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createFlaggedCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<CreateFlaggedCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).post<CreateFlaggedCommentByPlatformResponses, createFlaggedCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/{commentID}/flag',
            ...options
        });
    }
}

export class CommentLikeService {
    /**
     * Create a like
     *
     * Like a comment as a logged in user.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createLikeCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateLikeCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateLikeCommentByDomainIdResponses, createLikeCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/{commentID}/like',
            ...options
        });
    }
    
    /**
     * Delete a like from a comment
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteLikeCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteLikeCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteLikeCommentByDomainIdResponses, deleteLikeCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/like/{commentID}',
            ...options
        });
    }
    
    /**
     * Get articles thumbs by userID
     *
     * Return a list of newsThumbs of an article based on userID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listLikeCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<ListLikeCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListLikeCommentByDomainIdResponses, listLikeCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/comment/{newsID}/{userID}/user-likes',
            ...options
        });
    }
    
    /**
     * Create a like
     *
     * Like a comment as a logged in user.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createLikeCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<CreateLikeCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).post<CreateLikeCommentByPlatformResponses, createLikeCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/{commentID}/like',
            ...options
        });
    }
    
    /**
     * Delete a like from a comment
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteLikeCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<DeleteLikeCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteLikeCommentByPlatformResponses, deleteLikeCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/like/{commentID}',
            ...options
        });
    }
    
    /**
     * Get articles thumbs by userID
     *
     * Return a list of newsThumbs of an article based on userID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listLikeCommentByPlatform<ThrowOnError extends boolean = false>(options: Options<ListLikeCommentByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<ListLikeCommentByPlatformResponses, listLikeCommentByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/comment/{newsID}/{userID}/user-likes',
            ...options
        });
    }
}

export class FeaturedCarouselService {
    /**
     * Get headline items for a given contextID
     *
     * Get headline items for a given contextID
     */
    public static getFeaturedCarouselByDomainId<ThrowOnError extends boolean = false>(options: Options<GetFeaturedCarouselByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetFeaturedCarouselByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/featured-carousel', ...options });
    }
}

export class MatchTickerService {
    /**
     * Deletes all match ticker items.
     *
     * Deletes match ticker items by contextID. It returns 404 if no items were found.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteAllMatchTickerByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteAllMatchTickerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteAllMatchTickerByDomainIdResponses, deleteAllMatchTickerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/match-ticker',
            ...options
        });
    }
    
    /**
     * List match ticker items
     *
     * Returns a list of match ticker items selected by contextID.
     */
    public static listMatchTickerByDomainId<ThrowOnError extends boolean = false>(options: Options<ListMatchTickerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListMatchTickerByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/match-ticker', ...options });
    }
    
    /**
     * Create match ticker item
     *
     * Creates match ticker item for selected context.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createMatchTickerByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateMatchTickerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateMatchTickerByDomainIdResponses, createMatchTickerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/match-ticker',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes match ticker item
     *
     * Deletes match ticker item by contextID and matchID. It returns 404 if the match ticker item was not found.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteMatchTickerByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteMatchTickerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteMatchTickerByDomainIdResponses, deleteMatchTickerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/match-ticker/{matchID}',
            ...options
        });
    }
    
    /**
     * Updates match ticker item
     *
     * Updates match ticker item by contextID and matchID.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchMatchTickerByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchMatchTickerByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchMatchTickerByDomainIdResponses, patchMatchTickerByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/match-ticker/{matchID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ModuleScheduleService {
    /**
     * Get module schedule items
     *
     * Return a list of module schedule items for a given domainID or platform and locale
     */
    public static listModuleScheduleByDomainId<ThrowOnError extends boolean = false>(options: Options<ListModuleScheduleByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListModuleScheduleByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/module-schedule', ...options });
    }
    
    /**
     * Create a module schedule item
     *
     * Create a module schedule item. The response contains the newly created module schedule item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createModuleScheduleByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateModuleScheduleByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateModuleScheduleByDomainIdResponses, createModuleScheduleByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/module-schedule',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing module schedule item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteModuleScheduleByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteModuleScheduleByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteModuleScheduleByDomainIdResponses, deleteModuleScheduleByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/module-schedule/{id}',
            ...options
        });
    }
    
    /**
     * Update an existing module schedule item
     *
     * Update an existing module schedule item. The response is an updated version of the updated module schedule item
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchModuleScheduleByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchModuleScheduleByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchModuleScheduleByDomainIdResponses, patchModuleScheduleByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/module-schedule/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get module schedule items
     *
     * Return a list of module schedule items for a given domainID or platform and locale
     */
    public static listModuleScheduleByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<ListModuleScheduleByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).get<ListModuleScheduleByPlatformLocaleResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/locale/{locale}/module-schedule', ...options });
    }
    
    /**
     * Create a module schedule item
     *
     * Create a module schedule item. The response contains the newly created module schedule item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createModuleScheduleByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<CreateModuleScheduleByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).post<CreateModuleScheduleByPlatformLocaleResponses, createModuleScheduleByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/module-schedule',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing module schedule item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteModuleScheduleByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<DeleteModuleScheduleByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteModuleScheduleByPlatformLocaleResponses, deleteModuleScheduleByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/module-schedule/{id}',
            ...options
        });
    }
    
    /**
     * Update an existing module schedule item
     *
     * Update an existing module schedule item. The response is an updated version of the updated module schedule item
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchModuleScheduleByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<PatchModuleScheduleByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchModuleScheduleByPlatformLocaleResponses, patchModuleScheduleByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/module-schedule/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class NavItemService {
    /**
     * Get nav item by contextID
     *
     * Return a list of navigation items for a given contextID
     */
    public static listNavItemByDomainId<ThrowOnError extends boolean = false>(options: Options<ListNavItemByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListNavItemByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/nav-item', ...options });
    }
    
    /**
     * Create a new navigation item
     *
     * Creates and returns a new navigation item
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createNavItemByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateNavItemByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateNavItemByDomainIdResponses, createNavItemByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/nav-item',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing navigation item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteNavItemByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteNavItemByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteNavItemByDomainIdResponses, deleteNavItemByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/nav-item/{navItemID}',
            ...options
        });
    }
    
    /**
     * Update an existing navigation item
     *
     * Updates and returns the edited navigation item
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchNavItemByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchNavItemByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchNavItemByDomainIdResponses, patchNavItemByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/nav-item/{navItemID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class NewsCategoryService {
    /**
     * Get news categories
     *
     * Return a list of news categories for a given contextID
     */
    public static listNewsCategoryByDomainId<ThrowOnError extends boolean = false>(options: Options<ListNewsCategoryByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListNewsCategoryByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news-category', ...options });
    }
    
    /**
     * Get news category by slug.
     *
     * Get news category by slug.
     */
    public static getBySlugNewsCategoryByDomainId<ThrowOnError extends boolean = false>(options: Options<GetBySlugNewsCategoryByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetBySlugNewsCategoryByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news-category/{slug}', ...options });
    }
    
    /**
     * Get news category by functionality.
     *
     * Get news category by functionality.
     */
    public static getByFunctionalityNewsCategoryByDomainId<ThrowOnError extends boolean = false>(options: Options<GetByFunctionalityNewsCategoryByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetByFunctionalityNewsCategoryByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news-category/functionality/{functionality}', ...options });
    }
    
    /**
     * Update news category
     *
     * Update news category
     */
    public static patchNewsCategoryByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchNewsCategoryByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchNewsCategoryByDomainIdResponses, patchNewsCategoryByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/news-category/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class NewsService {
    /**
     * Get recent news articles
     *
     * Return a list of news articles for a given contextID created in the last year or filtered by title
     */
    public static listNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<ListNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news', ...options });
    }
    
    /**
     * Create a news article
     *
     * Create a news article and respond with the newly created article.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateNewsByDomainIdResponses, createNewsByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/news',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get most commented news articles
     *
     * Return a list of most commented news articles for a given contextID
     */
    public static getMostCommentedNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetMostCommentedNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetMostCommentedNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/most-commented', ...options });
    }
    
    /**
     * Get news articles related to an Opta match
     *
     * Returns news articles tagged with either team, published within a timeframe around the match kickoff.
     */
    public static getMatchNewsNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetMatchNewsNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetMatchNewsNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/match/{id}', ...options });
    }
    
    /**
     * Get most read news articles
     *
     * Return a list of most read news articles for a given contextID
     */
    public static getMostReadNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetMostReadNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetMostReadNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/most-read', ...options });
    }
    
    /**
     * Get most read news articles cross edition
     *
     * Return a list of most read news article for each editionID
     */
    public static getMostReadCrossEditionNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetMostReadCrossEditionNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetMostReadCrossEditionNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/most-read/cross-edition', ...options });
    }
    
    /**
     * Get news item by path.
     *
     * Return a specific news item
     */
    public static getByPathNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetByPathNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetByPathNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/path', ...options });
    }
    
    /**
     * Checks if a newsItem has a tag
     *
     * Checks if a newsItem has a tag .hasTag === true if it has
     */
    public static pathHasTagNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<PathHasTagNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<PathHasTagNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/path-has-tag', ...options });
    }
    
    /**
     * Delete an existing news article
     *
     * Delete a news article
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteNewsByDomainIdResponses, deleteNewsByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/news/{id}',
            ...options
        });
    }
    
    /**
     * Get news item by id.
     *
     * Return a specific news item
     */
    public static getByIdNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetByIdNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/{id}', ...options });
    }
    
    /**
     * Endpoint to patch an existing news article.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchNewsByDomainIdResponses, patchNewsByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/news/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deprecated: Use [getByPath](#/News/getByPathNewsByDomainID) instead.
     *
     * Get news item by original ID.
     *
     * @deprecated
     */
    public static getByOriginalIdNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetByOriginalIdNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetByOriginalIdNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/original/{originalID}', ...options });
    }
    
    /**
     * Deprecated: Use [getByPath](#/News/getByPathNewsByDomainID) instead.
     *
     * Get news item by slug.
     *
     * @deprecated
     */
    public static getBySlugNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetBySlugNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetBySlugNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/slug/{slug}', ...options });
    }
    
    /**
     * Making sure ImageSize Enum is getting exported
     */
    public static getNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GetNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/newsimageSize', ...options });
    }
    
    /**
     * Increase the news visit count.
     */
    public static increaseVisitCountNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<IncreaseVisitCountNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<IncreaseVisitCountNewsByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news/{newsID}/visit', ...options });
    }
    
    /**
     * Send push notifications.
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 30000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static sendPushNotificationsNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<SendPushNotificationsNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<SendPushNotificationsNewsByDomainIdResponses, sendPushNotificationsNewsByDomainIdErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/domain/{contextID}/news/send-push-notifications',
            ...options
        });
    }
    
    /**
     * Generate contentShort and contentSearchable for articles where these are missing.
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 30000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static generateShortAndSearchableNewsByDomainId<ThrowOnError extends boolean = false>(options: Options<GenerateShortAndSearchableNewsByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<GenerateShortAndSearchableNewsByDomainIdResponses, generateShortAndSearchableNewsByDomainIdErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/domain/{contextID}/news/generate-short-and-searchable',
            ...options
        });
    }
}

export class NewsMarketingBlockService {
    /**
     * Delete an existing marketing news block for a given context
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteNewsMarketingBlockByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteNewsMarketingBlockByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteNewsMarketingBlockByDomainIdResponses, deleteNewsMarketingBlockByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/news-marketing-block',
            ...options
        });
    }
    
    /**
     * Get marketing block item by domain
     *
     * Return marketing block item for a given context
     */
    public static getNewsMarketingBlockByDomainId<ThrowOnError extends boolean = false>(options: Options<GetNewsMarketingBlockByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetNewsMarketingBlockByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/news-marketing-block', ...options });
    }
    
    /**
     * Update an existing marketing news block item
     *
     * Updates and returns the edited marketing news block item
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchNewsMarketingBlockByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchNewsMarketingBlockByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchNewsMarketingBlockByDomainIdResponses, patchNewsMarketingBlockByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/news-marketing-block',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a new marketing news block
     *
     * Creates and returns a new marketing news block for a gives context
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createNewsMarketingBlockByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateNewsMarketingBlockByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateNewsMarketingBlockByDomainIdResponses, createNewsMarketingBlockByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/news-marketing-block',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class NotificationBarService {
    /**
     * Get all notification bar items
     *
     * Return a list of notification bar items for a given contextID or platform and locale
     */
    public static listNotificationBarByDomainId<ThrowOnError extends boolean = false>(options: Options<ListNotificationBarByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListNotificationBarByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/notification-bar', ...options });
    }
    
    /**
     * Create a notification bar item
     *
     * Create a notification bar item and respond with the newly created item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createNotificationBarByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateNotificationBarByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateNotificationBarByDomainIdResponses, createNotificationBarByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification-bar',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing notification bar item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteNotificationBarByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteNotificationBarByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteNotificationBarByDomainIdResponses, deleteNotificationBarByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification-bar/{id}',
            ...options
        });
    }
    
    /**
     * Update a notification bar item
     *
     * Update an existing notification bar item. The response is an updated version of the updated notification bar item
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchNotificationBarByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchNotificationBarByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchNotificationBarByDomainIdResponses, patchNotificationBarByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification-bar/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get all notification bar items
     *
     * Return a list of notification bar items for a given contextID or platform and locale
     */
    public static listNotificationBarByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<ListNotificationBarByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).get<ListNotificationBarByPlatformLocaleResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/locale/{locale}/notification-bar', ...options });
    }
    
    /**
     * Create a notification bar item
     *
     * Create a notification bar item and respond with the newly created item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createNotificationBarByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<CreateNotificationBarByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).post<CreateNotificationBarByPlatformLocaleResponses, createNotificationBarByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/notification-bar',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing notification bar item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteNotificationBarByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<DeleteNotificationBarByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteNotificationBarByPlatformLocaleResponses, deleteNotificationBarByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/notification-bar/{id}',
            ...options
        });
    }
    
    /**
     * Update a notification bar item
     *
     * Update an existing notification bar item. The response is an updated version of the updated notification bar item
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchNotificationBarByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<PatchNotificationBarByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchNotificationBarByPlatformLocaleResponses, patchNotificationBarByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/notification-bar/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class NotificationService {
    /**
     * Get all notifications for a user
     *
     * Return a list of comments for a given contextID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listNotificationByDomainId<ThrowOnError extends boolean = false>(options: Options<ListNotificationByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListNotificationByDomainIdResponses, listNotificationByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification',
            ...options
        });
    }
    
    /**
     * Marks all Notifications for a user as read
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static markAllAsReadNotificationByDomainId<ThrowOnError extends boolean = false>(options: Options<MarkAllAsReadNotificationByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<MarkAllAsReadNotificationByDomainIdResponses, markAllAsReadNotificationByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification/mark-as-read',
            ...options
        });
    }
    
    /**
     * Marks a given Notification as read
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static markAsReadNotificationByDomainId<ThrowOnError extends boolean = false>(options: Options<MarkAsReadNotificationByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<MarkAsReadNotificationByDomainIdResponses, markAsReadNotificationByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification/{id}/mark-as-read',
            ...options
        });
    }
    
    /**
     * Marks a list of Notifications as read
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static markSelectedAsReadNotificationByDomainId<ThrowOnError extends boolean = false>(options: Options<MarkSelectedAsReadNotificationByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<MarkSelectedAsReadNotificationByDomainIdResponses, markSelectedAsReadNotificationByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification/mark-selected-as-read',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get the number of unread notifications for an user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static getUnreadNotificationsCountNotificationByDomainId<ThrowOnError extends boolean = false>(options: Options<GetUnreadNotificationsCountNotificationByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetUnreadNotificationsCountNotificationByDomainIdResponses, getUnreadNotificationsCountNotificationByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/notification/unread-count',
            ...options
        });
    }
    
    /**
     * Get all notifications for a user
     *
     * Return a list of comments for a given contextID.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listNotificationByPlatform<ThrowOnError extends boolean = false>(options: Options<ListNotificationByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<ListNotificationByPlatformResponses, listNotificationByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/notification',
            ...options
        });
    }
    
    /**
     * Marks all Notifications for a user as read
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static markAllAsReadNotificationByPlatform<ThrowOnError extends boolean = false>(options: Options<MarkAllAsReadNotificationByPlatformData, ThrowOnError>) {
        return (options.client ?? client).patch<MarkAllAsReadNotificationByPlatformResponses, markAllAsReadNotificationByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/notification/mark-as-read',
            ...options
        });
    }
    
    /**
     * Marks a given Notification as read
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static markAsReadNotificationByPlatform<ThrowOnError extends boolean = false>(options: Options<MarkAsReadNotificationByPlatformData, ThrowOnError>) {
        return (options.client ?? client).patch<MarkAsReadNotificationByPlatformResponses, markAsReadNotificationByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/notification/{id}/mark-as-read',
            ...options
        });
    }
    
    /**
     * Marks a list of Notifications as read
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static markSelectedAsReadNotificationByPlatform<ThrowOnError extends boolean = false>(options: Options<MarkSelectedAsReadNotificationByPlatformData, ThrowOnError>) {
        return (options.client ?? client).patch<MarkSelectedAsReadNotificationByPlatformResponses, markSelectedAsReadNotificationByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/notification/mark-selected-as-read',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get the number of unread notifications for an user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static getUnreadNotificationsCountNotificationByPlatform<ThrowOnError extends boolean = false>(options: Options<GetUnreadNotificationsCountNotificationByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<GetUnreadNotificationsCountNotificationByPlatformResponses, getUnreadNotificationsCountNotificationByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/notification/unread-count',
            ...options
        });
    }
}

export class PollService {
    /**
     * Delete an existing poll with its answers
     *
     * Deletes and returns 204 if the request succeeds
     *
     * - Allowed roles: editor, admin
     */
    public static deletePollByDomainId<ThrowOnError extends boolean = false>(options: Options<DeletePollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeletePollByDomainIdResponses, deletePollByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/poll/{id}',
            ...options
        });
    }
    
    /**
     * Get poll by id
     *
     * Return a poll with a given pollID
     */
    public static getPollByIdPollByDomainId<ThrowOnError extends boolean = false>(options: Options<GetPollByIdPollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetPollByIdPollByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/poll/{id}', ...options });
    }
    
    /**
     * Patch poll
     *
     * - Allowed roles: editor, admin
     */
    public static patchPollByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchPollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchPollByDomainIdResponses, patchPollByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/poll/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get polls
     *
     * Return a list of polls for a given contextID
     */
    public static listPollByDomainId<ThrowOnError extends boolean = false>(options: Options<ListPollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListPollByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/poll', ...options });
    }
    
    /**
     * Create a poll
     *
     * Create poll including answers and respond with the newly created item.
     *
     * - Allowed roles: editor, admin
     */
    public static createPollByDomainId<ThrowOnError extends boolean = false>(options: Options<CreatePollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreatePollByDomainIdResponses, createPollByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/poll',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Vote for a poll
     */
    public static votePollByDomainId<ThrowOnError extends boolean = false>(options: Options<VotePollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<VotePollByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/poll/{pollID}/answer/{answerID}/vote', ...options });
    }
    
    /**
     * returns answer that has been voted by user's IP
     */
    public static getVotedAnswerIdPollByDomainId<ThrowOnError extends boolean = false>(options: Options<GetVotedAnswerIdPollByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetVotedAnswerIdPollByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/poll/{pollID}/voted-answer', ...options });
    }
}

export class SitemapService {
    /**
     * Get entries for navigation sitemap
     *
     * Return a list of entries for the navigation sitemap for a given platform ID
     */
    public static navigationSitemapByDomainId<ThrowOnError extends boolean = false>(options: Options<NavigationSitemapByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<NavigationSitemapByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/sitemap/navigation', ...options });
    }
    
    /**
     * Get entries for the index sitemap
     *
     * Get entries for the index sitemap for a given platform ID or contextID
     */
    public static indexSitemapByDomainId<ThrowOnError extends boolean = false>(options: Options<IndexSitemapByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<IndexSitemapByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/sitemap/index', ...options });
    }
    
    /**
     * Get sitemap entries for the news of a given week
     *
     * Get weekly entries for the sitemap of a given platform ID or contextID
     */
    public static newsSitemapByDomainId<ThrowOnError extends boolean = false>(options: Options<NewsSitemapByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<NewsSitemapByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/sitemap/news', ...options });
    }
    
    /**
     * Get sitemap entries for a given tag
     *
     * Get sitemap entries for a given tag on a given platform ID or contextID
     */
    public static tagsSitemapByDomainId<ThrowOnError extends boolean = false>(options: Options<TagsSitemapByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<TagsSitemapByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/sitemap/tag', ...options });
    }
    
    /**
     * Get sitemap entries for google news
     *
     * Get sitemap entries of the last 48 hours for google for a given platform ID or contextID
     */
    public static googleNewsSitemapByDomainId<ThrowOnError extends boolean = false>(options: Options<GoogleNewsSitemapByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GoogleNewsSitemapByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/sitemap/google', ...options });
    }
    
    /**
     * Get sitemap entries for author pages
     *
     * Get sitemap entries for author pages, with the estimated latest mod
     */
    public static authorPagesSitemapByDomainId<ThrowOnError extends boolean = false>(options: Options<AuthorPagesSitemapByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<AuthorPagesSitemapByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/sitemap/authors', ...options });
    }
    
    /**
     * Get entries for navigation sitemap
     *
     * Return a list of entries for the navigation sitemap for a given platform ID
     */
    public static navigationSitemapByPlatform<ThrowOnError extends boolean = false>(options: Options<NavigationSitemapByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<NavigationSitemapByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/sitemap/navigation', ...options });
    }
    
    /**
     * Get entries for the index sitemap
     *
     * Get entries for the index sitemap for a given platform ID or contextID
     */
    public static indexSitemapByPlatform<ThrowOnError extends boolean = false>(options: Options<IndexSitemapByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<IndexSitemapByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/sitemap/index', ...options });
    }
    
    /**
     * Get sitemap entries for the news of a given week
     *
     * Get weekly entries for the sitemap of a given platform ID or contextID
     */
    public static newsSitemapByPlatform<ThrowOnError extends boolean = false>(options: Options<NewsSitemapByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<NewsSitemapByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/sitemap/news', ...options });
    }
    
    /**
     * Get sitemap entries for a given tag
     *
     * Get sitemap entries for a given tag on a given platform ID or contextID
     */
    public static tagsSitemapByPlatform<ThrowOnError extends boolean = false>(options: Options<TagsSitemapByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<TagsSitemapByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/sitemap/tag', ...options });
    }
    
    /**
     * Get sitemap entries for google news
     *
     * Get sitemap entries of the last 48 hours for google for a given platform ID or contextID
     */
    public static googleNewsSitemapByPlatform<ThrowOnError extends boolean = false>(options: Options<GoogleNewsSitemapByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<GoogleNewsSitemapByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/sitemap/google', ...options });
    }
    
    /**
     * Get sitemap entries for author pages
     *
     * Get sitemap entries for author pages, with the estimated latest mod
     */
    public static authorPagesSitemapByPlatform<ThrowOnError extends boolean = false>(options: Options<AuthorPagesSitemapByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<AuthorPagesSitemapByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/sitemap/authors', ...options });
    }
}

export class TagService {
    /**
     * Get a list of tags.
     *
     * Return a list of tags. ContextID will be used to localize tag data.
     */
    public static listTagByDomainId<ThrowOnError extends boolean = false>(options: Options<ListTagByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListTagByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/tag', ...options });
    }
    
    /**
     * Get tag types by context.
     */
    public static getTagTypesTagByDomainId<ThrowOnError extends boolean = false>(options: Options<GetTagTypesTagByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetTagTypesTagByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/tag/types', ...options });
    }
    
    /**
     * Get tag by slug or ID.
     *
     * Get tag by slug or ID. ContextID will be used to localize tag data.
     */
    public static getBySlugTagByDomainId<ThrowOnError extends boolean = false>(options: Options<GetBySlugTagByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetBySlugTagByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/tag/{slugOrID}', ...options });
    }
    
    /**
     * Delete tags
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: admin
     */
    public static deleteTagByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteTagByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteTagByDomainIdResponses, deleteTagByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/tag/{tagID}',
            ...options
        });
    }
}

export class VideofeedConfigService {
    /**
     * Get videofeed config by contextID
     *
     * Return a videofeed config for a given contextID
     */
    public static getVideofeedConfigByDomainId<ThrowOnError extends boolean = false>(options: Options<GetVideofeedConfigByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetVideofeedConfigByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/videofeed-config', ...options });
    }
    
    /**
     * Create or update videofeed config by contextID
     *
     * Creates/updates and returns a videofeed config for a given contextID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static upsertVideofeedConfigByDomainId<ThrowOnError extends boolean = false>(options: Options<UpsertVideofeedConfigByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).put<UpsertVideofeedConfigByDomainIdResponses, upsertVideofeedConfigByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/videofeed-config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class VideofeedService {
    /**
     * Get all videofeed items.
     *
     * Return a list of videofeed items for a given contextID
     */
    public static listVideofeedByDomainId<ThrowOnError extends boolean = false>(options: Options<ListVideofeedByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListVideofeedByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/videofeed', ...options });
    }
    
    /**
     * Create new videofeed item.
     *
     * Create a videofeed item and respond with the newly created item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createVideofeedByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateVideofeedByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateVideofeedByDomainIdResponses, createVideofeedByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/videofeed',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Patch existing videofeed item.
     *
     * Patch existing videofeed item and respond with the updated item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchVideofeedByDomainId<ThrowOnError extends boolean = false>(options: Options<PatchVideofeedByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchVideofeedByDomainIdResponses, patchVideofeedByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/videofeed/{videofeedID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DisassociateUserService {
    /**
     * - Allowed roles: app_cron
     */
    public static syncDisassociateUser<ThrowOnError extends boolean = false>(options?: Options<SyncDisassociateUserData, ThrowOnError>) {
        return (options?.client ?? client).post<SyncDisassociateUserResponses, syncDisassociateUserErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/disassociate-user/disassociate',
            ...options
        });
    }
}

export class ContactFormService {
    /**
     * Generate a contact form email and a confirmation email.
     *
     * The allowed departments depend on the `editionID`:
     * | editionID | departments |
     * | --------- | ----------- |
     * | 1 | editorial |
     * | 2 | editorial |
     * | 200 | editorial, vi-kids, support |
     * | 300 | sales, editorial, moderators |
     * | 400 | editorial |
     */
    public static sendContactFormContactForm<ThrowOnError extends boolean = false>(options: Options<SendContactFormContactFormData, ThrowOnError>) {
        return (options.client ?? client).post<SendContactFormContactFormResponses, unknown, ThrowOnError>({
            url: '/edition/{editionID}/contact-form',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * This endpoint only exists to add the `DepartmentsByEdition` model to the OpenAPI Specification. It will always return status 403.
     */
    public static getDepartmentsByEditionContactForm<ThrowOnError extends boolean = false>(options: Options<GetDepartmentsByEditionContactFormData, ThrowOnError>) {
        return (options.client ?? client).get<GetDepartmentsByEditionContactFormResponses, getDepartmentsByEditionContactFormErrors, ThrowOnError>({ url: '/edition/{editionID}/contact-form/departments-by-edition', ...options });
    }
}

export class CurationService {
    /**
     * Delete curated news
     *
     * - Allowed roles: admin
     */
    public static deleteCuration<ThrowOnError extends boolean = false>(options: Options<DeleteCurationData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCurationResponses, deleteCurationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation',
            ...options
        });
    }
    
    /**
     * Get curated news for a given editionID
     */
    public static getCuration<ThrowOnError extends boolean = false>(options: Options<GetCurationData, ThrowOnError>) {
        return (options.client ?? client).get<GetCurationResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/curation', ...options });
    }
    
    /**
     * Update a curated news
     *
     * - Allowed roles: editor, admin
     */
    public static updateCuration<ThrowOnError extends boolean = false>(options: Options<UpdateCurationData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateCurationResponses, updateCurationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a curated news
     *
     * - Allowed roles: editor, admin
     */
    public static createCuration<ThrowOnError extends boolean = false>(options: Options<CreateCurationData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCurationResponses, createCurationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Cron endpoint to reschedule curation
     *
     * Unpublishing expired items and (TODO: enable scheduled items
     *
     * - Allowed roles: app_cron
     */
    public static rescheduleCuration<ThrowOnError extends boolean = false>(options: Options<RescheduleCurationData, ThrowOnError>) {
        return (options.client ?? client).post<RescheduleCurationResponses, rescheduleCurationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/edition/{editionID}/curation/reschedule',
            ...options
        });
    }
}

export class CuratedMatchService {
    /**
     * Patch a curated match
     *
     * - Allowed roles: editor, admin
     */
    public static patchCuratedMatch<ThrowOnError extends boolean = false>(options: Options<PatchCuratedMatchData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchCuratedMatchResponses, patchCuratedMatchErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation/match/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CuratedNewsItemService {
    /**
     * Delete curated news item
     *
     * - Allowed roles: editor, admin
     */
    public static deleteCuratedNewsItem<ThrowOnError extends boolean = false>(options: Options<DeleteCuratedNewsItemData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCuratedNewsItemResponses, deleteCuratedNewsItemErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation/news/{id}',
            ...options
        });
    }
    
    /**
     * Get curated news item for a given id
     */
    public static getCuratedNewsItem<ThrowOnError extends boolean = false>(options: Options<GetCuratedNewsItemData, ThrowOnError>) {
        return (options.client ?? client).get<GetCuratedNewsItemResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/curation/news/{id}', ...options });
    }
    
    /**
     * Update a curated news item
     *
     * - Allowed roles: editor, admin
     */
    public static updateCuratedNewsItem<ThrowOnError extends boolean = false>(options: Options<UpdateCuratedNewsItemData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateCuratedNewsItemResponses, updateCuratedNewsItemErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation/news/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a curated news item
     *
     * - Allowed roles: editor, admin
     */
    public static createCuratedNewsItem<ThrowOnError extends boolean = false>(options: Options<CreateCuratedNewsItemData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCuratedNewsItemResponses, createCuratedNewsItemErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation/news',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CuratedMarketingItemService {
    /**
     * Delete curated marketing item
     *
     * - Allowed roles: editor, admin
     */
    public static deleteCuratedMarketingItem<ThrowOnError extends boolean = false>(options: Options<DeleteCuratedMarketingItemData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCuratedMarketingItemResponses, deleteCuratedMarketingItemErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation/marketing/{id}',
            ...options
        });
    }
    
    /**
     * Get curated marketing item for a given id
     */
    public static getCuratedMarketingItem<ThrowOnError extends boolean = false>(options: Options<GetCuratedMarketingItemData, ThrowOnError>) {
        return (options.client ?? client).get<GetCuratedMarketingItemResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/curation/marketing/{id}', ...options });
    }
    
    /**
     * Update a curated marketing item
     *
     * - Allowed roles: editor, admin
     */
    public static updateCuratedMarketingItem<ThrowOnError extends boolean = false>(options: Options<UpdateCuratedMarketingItemData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateCuratedMarketingItemResponses, updateCuratedMarketingItemErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation/marketing/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a curated marketing item
     *
     * - Allowed roles: editor, admin
     */
    public static createCuratedMarketingItem<ThrowOnError extends boolean = false>(options: Options<CreateCuratedMarketingItemData, ThrowOnError>) {
        return (options.client ?? client).post<CreateCuratedMarketingItemResponses, createCuratedMarketingItemErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/curation/marketing',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class EmbedHtmlService {
    /**
     * Get X Post Embed
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static xPostEmbedEmbedHtml<ThrowOnError extends boolean = false>(options: Options<XPostEmbedEmbedHtmlData, ThrowOnError>) {
        return (options.client ?? client).get<XPostEmbedEmbedHtmlResponses, xPostEmbedEmbedHtmlErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/embed-htmlxPost',
            ...options
        });
    }
}

export class EventService {
    /**
     * Log a Meta Conversion Event
     *
     * Accepts a Meta (CAPI) event and forwards it to the logging service.
     */
    public static logEvent<ThrowOnError extends boolean = false>(options: Options<LogEventData, ThrowOnError>) {
        return (options.client ?? client).post<LogEventResponses, unknown, ThrowOnError>({
            url: '/edition/{editionID}/event/log',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * - Allowed roles: app_cron
     */
    public static batchEvent<ThrowOnError extends boolean = false>(options: Options<BatchEventData, ThrowOnError>) {
        return (options.client ?? client).post<BatchEventResponses, batchEventErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/edition/{editionID}/event/batch',
            ...options
        });
    }
    
    /**
     * Deletes the 'test_event_code' for Conversion API QA/Staging testing
     *
     * - Allowed roles: admin
     */
    public static deleteTestTokenEvent<ThrowOnError extends boolean = false>(options: Options<DeleteTestTokenEventData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteTestTokenEventResponses, deleteTestTokenEventErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/event/test-token',
            ...options
        });
    }
    
    /**
     * Set the 'test_event_code' for Conversion API QA/Staging testing
     *
     * - Allowed roles: admin
     */
    public static setTestTokenEvent<ThrowOnError extends boolean = false>(options: Options<SetTestTokenEventData, ThrowOnError>) {
        return (options.client ?? client).post<SetTestTokenEventResponses, setTestTokenEventErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/event/test-token',
            ...options
        });
    }
}

export class FaqCategoryService {
    /**
     * Get all faqs
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listFaqCategory<ThrowOnError extends boolean = false>(options: Options<ListFaqCategoryData, ThrowOnError>) {
        return (options.client ?? client).get<ListFaqCategoryResponses, listFaqCategoryErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq-category',
            ...options
        });
    }
    
    /**
     * Create a faqCategory
     *
     * Create a faqCategory. The response contains the newly created faqCategory.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createFaqCategory<ThrowOnError extends boolean = false>(options: Options<CreateFaqCategoryData, ThrowOnError>) {
        return (options.client ?? client).post<CreateFaqCategoryResponses, createFaqCategoryErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq-category',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing faqCategory
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteByIdFaqCategory<ThrowOnError extends boolean = false>(options: Options<DeleteByIdFaqCategoryData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteByIdFaqCategoryResponses, deleteByIdFaqCategoryErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq-category/{faqCategoryID}',
            ...options
        });
    }
    
    /**
     * Get faqCategory by ID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdFaqCategory<ThrowOnError extends boolean = false>(options: Options<GetByIdFaqCategoryData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdFaqCategoryResponses, getByIdFaqCategoryErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq-category/{faqCategoryID}',
            ...options
        });
    }
    
    /**
     * Patch a FaqCategory
     *
     * Patch a FaqCategory and returns the patched FaqCategory
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchFaqCategory<ThrowOnError extends boolean = false>(options: Options<PatchFaqCategoryData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchFaqCategoryResponses, patchFaqCategoryErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq-category/{faqCategoryID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class FaqService {
    /**
     * Get all faqs
     */
    public static listFaq<ThrowOnError extends boolean = false>(options: Options<ListFaqData, ThrowOnError>) {
        return (options.client ?? client).get<ListFaqResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/faq', ...options });
    }
    
    /**
     * Create a faq
     *
     * Create a faq. The response contains the newly created faq.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createFaq<ThrowOnError extends boolean = false>(options: Options<CreateFaqData, ThrowOnError>) {
        return (options.client ?? client).post<CreateFaqResponses, createFaqErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing faq
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteByIdFaq<ThrowOnError extends boolean = false>(options: Options<DeleteByIdFaqData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteByIdFaqResponses, deleteByIdFaqErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq/{faqID}',
            ...options
        });
    }
    
    /**
     * Get faq by ID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdFaq<ThrowOnError extends boolean = false>(options: Options<GetByIdFaqData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdFaqResponses, getByIdFaqErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq/{faqID}',
            ...options
        });
    }
    
    /**
     * Patch a Faq
     *
     * Patch a Faq and returns the patched Faq
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchFaq<ThrowOnError extends boolean = false>(options: Options<PatchFaqData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchFaqResponses, patchFaqErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/faq/{faqID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class FeatureFlagService {
    /**
     * Get all featureFlags
     */
    public static listFeatureFlag<ThrowOnError extends boolean = false>(options: Options<ListFeatureFlagData, ThrowOnError>) {
        return (options.client ?? client).get<ListFeatureFlagResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/featureFlag', ...options });
    }
}

export class HearstMigrationControllerService {
    /**
     * Import Hearst articles by sending in an XML file
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static importHearstArticlesHearstMigration<ThrowOnError extends boolean = false>(options: Options<ImportHearstArticlesHearstMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ImportHearstArticlesHearstMigrationResponses, importHearstArticlesHearstMigrationErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/hearst-migration/import',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Replace links in articles with our own links.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static replaceLinksHearstMigration<ThrowOnError extends boolean = false>(options: Options<ReplaceLinksHearstMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ReplaceLinksHearstMigrationResponses, replaceLinksHearstMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/hearst-migration/replace-links',
            ...options
        });
    }
    
    /**
     * Replace affiliate links in articles with our own links.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static replaceAffiliateLinksHearstMigration<ThrowOnError extends boolean = false>(options: Options<ReplaceAffiliateLinksHearstMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ReplaceAffiliateLinksHearstMigrationResponses, replaceAffiliateLinksHearstMigrationErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/hearst-migration/replace-affiliate-links',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Export all external links and number of links per domain to a file.
     */
    public static exportAffiliateLinksHearstMigration<ThrowOnError extends boolean = false>(options: Options<ExportAffiliateLinksHearstMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<unknown, exportAffiliateLinksHearstMigrationErrors, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/edition/{editionID}/hearst-migration/affiliate-links',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Enrich the author users with the author JSON files Hearst has provided us.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static importAuthorsHearstMigration<ThrowOnError extends boolean = false>(options: Options<ImportAuthorsHearstMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ImportAuthorsHearstMigrationResponses, importAuthorsHearstMigrationErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/hearst-migration/authors',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Create Supertokens users for the newly created Hearst authors. This should be run after all articles and authors have already been imported.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createSupertokensUsersHearstMigration<ThrowOnError extends boolean = false>(options: Options<CreateSupertokensUsersHearstMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<CreateSupertokensUsersHearstMigrationResponses, createSupertokensUsersHearstMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/hearst-migration/supertokens',
            ...options
        });
    }
    
    /**
     * Replace old listicle XML format with new structure accepted by the Listicle blocks.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static reformatListicleBlocksHearstMigration<ThrowOnError extends boolean = false>(options: Options<ReformatListicleBlocksHearstMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ReformatListicleBlocksHearstMigrationResponses, reformatListicleBlocksHearstMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/hearst-migration/reformat-listicle-blocks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class MenuService {
    /**
     * Get menu items
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listMenu<ThrowOnError extends boolean = false>(options: Options<ListMenuData, ThrowOnError>) {
        return (options.client ?? client).get<ListMenuResponses, listMenuErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/menu',
            ...options
        });
    }
}

export class MobileConfigService {
    /**
     * Get mobile config key by edition
     */
    public static getMobileConfig<ThrowOnError extends boolean = false>(options: Options<GetMobileConfigData, ThrowOnError>) {
        return (options.client ?? client).get<GetMobileConfigResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/mobile-config/{client}', ...options });
    }
    
    /**
     * Update mobile config key by edition
     *
     * - Allowed roles: admin
     */
    public static putMobileConfig<ThrowOnError extends boolean = false>(options: Options<PutMobileConfigData, ThrowOnError>) {
        return (options.client ?? client).put<PutMobileConfigResponses, putMobileConfigErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/mobile-config/{client}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get mobile config key by platform
     *
     * Return a config item for a given platform
     *
     * @deprecated
     */
    public static getDeprecatedMobileConfig<ThrowOnError extends boolean = false>(options: Options<GetDeprecatedMobileConfigData, ThrowOnError>) {
        return (options.client ?? client).get<GetDeprecatedMobileConfigResponses, unknown, ThrowOnError>({ url: '/mobile-config', ...options });
    }
}

export class ExternalSnippetService {
    /**
     * Get all external snippets
     */
    public static listExternalSnippet<ThrowOnError extends boolean = false>(options: Options<ListExternalSnippetData, ThrowOnError>) {
        return (options.client ?? client).get<ListExternalSnippetResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/external-snippet', ...options });
    }
    
    /**
     * Get all external-snippets, grouped by placement
     */
    public static listGroupedByPlacementExternalSnippet<ThrowOnError extends boolean = false>(options: Options<ListGroupedByPlacementExternalSnippetData, ThrowOnError>) {
        return (options.client ?? client).get<ListGroupedByPlacementExternalSnippetResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/external-snippet/grouped-by-placement', ...options });
    }
    
    /**
     * Upsert an external-snippet placement
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static updateExternalSnippet<ThrowOnError extends boolean = false>(options: Options<UpdateExternalSnippetData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateExternalSnippetResponses, updateExternalSnippetErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/external-snippet/{placement}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class NewsBookmarkService {
    /**
     * Get news articles bookmarked by the user
     *
     * Return a list of bookmarked news articles for a given contextID and user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listNewsBookmark<ThrowOnError extends boolean = false>(options: Options<ListNewsBookmarkData, ThrowOnError>) {
        return (options.client ?? client).get<ListNewsBookmarkResponses, listNewsBookmarkErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/news-bookmark',
            ...options
        });
    }
    
    /**
     * Get newsIDs bookmarked by the user
     *
     * Return a list of bookmarked newsIDs for a given contextID and user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listIdsNewsBookmark<ThrowOnError extends boolean = false>(options: Options<ListIdsNewsBookmarkData, ThrowOnError>) {
        return (options.client ?? client).get<ListIdsNewsBookmarkResponses, listIdsNewsBookmarkErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/news-bookmark/ids',
            ...options
        });
    }
    
    /**
     * Remove a bookmarked news item for user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteNewsBookmark<ThrowOnError extends boolean = false>(options: Options<DeleteNewsBookmarkData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteNewsBookmarkResponses, deleteNewsBookmarkErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/news-bookmark/{newsID}',
            ...options
        });
    }
    
    /**
     * Bookmark a news item for user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static postNewsBookmark<ThrowOnError extends boolean = false>(options: Options<PostNewsBookmarkData, ThrowOnError>) {
        return (options.client ?? client).post<PostNewsBookmarkResponses, postNewsBookmarkErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/news-bookmark/{newsID}',
            ...options
        });
    }
}

export class OriginalRedirectService {
    /**
     * Get a redirect by path
     *
     * Returns a single redirect
     */
    public static getOriginalRedirect<ThrowOnError extends boolean = false>(options: Options<GetOriginalRedirectData, ThrowOnError>) {
        return (options.client ?? client).get<GetOriginalRedirectResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/original-redirect/{path}', ...options });
    }
}

export class PageService {
    /**
     * Get pages
     *
     * Return a list of pages for the current context.
     *
     * - Allowed roles: editor, admin, app_next_web
     */
    public static listPage<ThrowOnError extends boolean = false>(options: Options<ListPageData, ThrowOnError>) {
        return (options.client ?? client).get<ListPageResponses, listPageErrors, ThrowOnError>({
            security: [
                {
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                },
                { name: 'auth-app-name', type: 'apiKey' },
                { name: 'auth-app-password', type: 'apiKey' }
            ],
            url: '/edition/{editionID}/page',
            ...options
        });
    }
    
    /**
     * Create a page
     *
     * Create a page and respond with the created page.
     *
     * - Allowed roles: editor, admin
     */
    public static createPage<ThrowOnError extends boolean = false>(options: Options<CreatePageData, ThrowOnError>) {
        return (options.client ?? client).post<CreatePageResponses, createPageErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/page',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get page by full path & contextID
     *
     * Return entities for a specific page
     */
    public static getByPathPage<ThrowOnError extends boolean = false>(options: Options<GetByPathPageData, ThrowOnError>) {
        return (options.client ?? client).get<GetByPathPageResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/page/by-path', ...options });
    }
    
    /**
     * Get page by slug & contextID
     *
     * Return entities for a specific page
     */
    public static getPage<ThrowOnError extends boolean = false>(options: Options<GetPageData, ThrowOnError>) {
        return (options.client ?? client).get<GetPageResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/page/{slug}', ...options });
    }
    
    /**
     * Deletes a page
     *
     * Deletes and returns 204
     *
     * - Allowed roles: editor, admin
     */
    public static deletePage<ThrowOnError extends boolean = false>(options: Options<DeletePageData, ThrowOnError>) {
        return (options.client ?? client).delete<DeletePageResponses, deletePageErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/page/{id}',
            ...options
        });
    }
    
    /**
     * Update a page
     *
     * Patch a page and respond with the patched page.
     *
     * - Allowed roles: editor, admin
     */
    public static patchPage<ThrowOnError extends boolean = false>(options: Options<PatchPageData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchPageResponses, patchPageErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/page/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PlayerRatingService {
    /**
     * Get a list of player ratings based on filters
     *
     * Get a list of player ratings based on filters:
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listPlayerRating<ThrowOnError extends boolean = false>(options: Options<ListPlayerRatingData, ThrowOnError>) {
        return (options.client ?? client).get<ListPlayerRatingResponses, listPlayerRatingErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/player-rating',
            ...options
        });
    }
    
    /**
     * Create or update a playerRating
     *
     * Creates or updates a playerRating for the given edition
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchPlayerRating<ThrowOnError extends boolean = false>(options: Options<PatchPlayerRatingData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchPlayerRatingResponses, patchPlayerRatingErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/player-rating',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get opta player ratings for a match
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getOptaRatingsPlayerRating<ThrowOnError extends boolean = false>(options: Options<GetOptaRatingsPlayerRatingData, ThrowOnError>) {
        return (options.client ?? client).get<GetOptaRatingsPlayerRatingResponses, getOptaRatingsPlayerRatingErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/player-rating/opta/{optaID}',
            ...options
        });
    }
}

export class PrenlyControllerService {
    public static authenticateWithUsernameAndPasswordPrenly<ThrowOnError extends boolean = false>(options: Options<AuthenticateWithUsernameAndPasswordPrenlyData, ThrowOnError>) {
        return (options.client ?? client).post<AuthenticateWithUsernameAndPasswordPrenlyResponses, authenticateWithUsernameAndPasswordPrenlyErrors, ThrowOnError>({
            url: '/edition/{editionID}/prenly/authenticate-with-username-and-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getUserPrenly<ThrowOnError extends boolean = false>(options: Options<GetUserPrenlyData, ThrowOnError>) {
        return (options.client ?? client).post<GetUserPrenlyResponses, getUserPrenlyErrors, ThrowOnError>({
            url: '/edition/{editionID}/prenly/get-user',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SubscriptionService {
    /**
     * Get all propositions
     *
     * Return propositions from zeno
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listSubscription<ThrowOnError extends boolean = false>(options: Options<ListSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).get<ListSubscriptionResponses, listSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/propositions',
            ...options
        });
    }
    
    /**
     * Get all SubscriptionDetails
     *
     * Return SubscriptionDetails from zeno
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getSubscriptionDetailsSubscription<ThrowOnError extends boolean = false>(options: Options<GetSubscriptionDetailsSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).get<GetSubscriptionDetailsSubscriptionResponses, getSubscriptionDetailsSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/detail/{relationID}',
            ...options
        });
    }
    
    /**
     * Get all payment methods
     *
     * Return supported payment methods
     */
    public static getPaymentMethodsSubscription<ThrowOnError extends boolean = false>(options: Options<GetPaymentMethodsSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).get<GetPaymentMethodsSubscriptionResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/subscription/payment-methods', ...options });
    }
    
    /**
     * Updates a users subscription
     *
     * Access point for zeno / socho to update a users subscription
     *
     * - Allowed roles: app_socho
     */
    public static updateUserSubscription<ThrowOnError extends boolean = false>(options: Options<UpdateUserSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<UpdateUserSubscriptionResponses, updateUserSubscriptionErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/edition/{editionID}/subscription/update/{userID}/{relationNumber}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get subscription info for user
     *
     * Get info for users subscription from Zeno
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static getInfoSubscription<ThrowOnError extends boolean = false>(options: Options<GetInfoSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).get<GetInfoSubscriptionResponses, getInfoSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/info',
            ...options
        });
    }
    
    /**
     * Verifies if the user should be presented with the upsell view
     *
     * Based on the users subscriptions for this domain, do we need to show the switch/upsell page?
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static shouldSwitchSubscription<ThrowOnError extends boolean = false>(options: Options<ShouldSwitchSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).get<ShouldSwitchSubscriptionResponses, shouldSwitchSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/should-switch',
            ...options
        });
    }
    
    /**
     * Create a relation in Zeno
     *
     * Create a relation in Zeno and link this to the currently active user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createRelationSubscription<ThrowOnError extends boolean = false>(options: Options<CreateRelationSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<CreateRelationSubscriptionResponses, createRelationSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/create-relation',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update a relation address in Zeno
     *
     * Update a relation address in Zeno
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static updateRelationAddressSubscription<ThrowOnError extends boolean = false>(options: Options<UpdateRelationAddressSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<UpdateRelationAddressSubscriptionResponses, updateRelationAddressSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/update-relation-address',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Request payment link
     *
     * Request a payment link for a given subscription number
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static requestPaymentLinkSubscription<ThrowOnError extends boolean = false>(options: Options<RequestPaymentLinkSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<RequestPaymentLinkSubscriptionResponses, requestPaymentLinkSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/request-payment-link',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add subscription to Zeno relation
     *
     * Add subscription to Zeno relation for active user
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static addSubscriptionSubscription<ThrowOnError extends boolean = false>(options: Options<AddSubscriptionSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<AddSubscriptionSubscriptionResponses, addSubscriptionSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/add-subscription/{propositionID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Store time in payment succeeded log
     *
     * Just updates the log, doesn't send anything to ZENO
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static paymentSucceededSubscription<ThrowOnError extends boolean = false>(options: Options<PaymentSucceededSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<PaymentSucceededSubscriptionResponses, paymentSucceededSubscriptionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/payment-succeeded',
            ...options
        });
    }
    
    /**
     * Get address info for postalCode / houseNumber
     */
    public static lookupAddressSubscription<ThrowOnError extends boolean = false>(options: Options<LookupAddressSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).get<LookupAddressSubscriptionResponses, lookupAddressSubscriptionErrors, ThrowOnError>({ url: '/edition/{editionID}/subscription/lookup/{postalCode}/{houseNumber}', ...options });
    }
    
    /**
     * Payment redirect links for zeno
     *
     * Based on provided propositionID we provide the success/failure url for this edition
     */
    public static redirectsSubscription<ThrowOnError extends boolean = false>(options: Options<RedirectsSubscriptionData, ThrowOnError>) {
        return (options.client ?? client).post<RedirectsSubscriptionResponses, unknown, ThrowOnError>({
            url: '/edition/{editionID}/subscription/redirects',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class GiftService {
    /**
     * Get list of gifts
     *
     * Return gifts for the given edition
     */
    public static listGiftsGift<ThrowOnError extends boolean = false>(options: Options<ListGiftsGiftData, ThrowOnError>) {
        return (options.client ?? client).get<ListGiftsGiftResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/subscription/gift', ...options });
    }
    
    /**
     * Create a subscription gift
     *
     * Create a subscription gift. The response contains the newly created gift item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createGift<ThrowOnError extends boolean = false>(options: Options<CreateGiftData, ThrowOnError>) {
        return (options.client ?? client).post<CreateGiftResponses, createGiftErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/gift',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing subscription gift item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteGift<ThrowOnError extends boolean = false>(options: Options<DeleteGiftData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteGiftResponses, deleteGiftErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/gift/{giftID}',
            ...options
        });
    }
    
    /**
     * Get gift by ID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdGift<ThrowOnError extends boolean = false>(options: Options<GetByIdGiftData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdGiftResponses, getByIdGiftErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/gift/{giftID}',
            ...options
        });
    }
    
    /**
     * Patch a subscription gift
     *
     * Patch a subscription gift returns the patched subscription gift.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchGift<ThrowOnError extends boolean = false>(options: Options<PatchGiftData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchGiftResponses, patchGiftErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/gift/{giftID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PropositionService {
    /**
     * Create a subscription proposition
     *
     * Create a subscription proposition. The response contains the newly created proposition item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createProposition<ThrowOnError extends boolean = false>(options: Options<CreatePropositionData, ThrowOnError>) {
        return (options.client ?? client).post<CreatePropositionResponses, createPropositionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/proposition',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing subscription proposition item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteByIdProposition<ThrowOnError extends boolean = false>(options: Options<DeleteByIdPropositionData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteByIdPropositionResponses, deleteByIdPropositionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/proposition/{propositionID}',
            ...options
        });
    }
    
    /**
     * Get proposition by ID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdProposition<ThrowOnError extends boolean = false>(options: Options<GetByIdPropositionData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdPropositionResponses, getByIdPropositionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/proposition/{propositionID}',
            ...options
        });
    }
    
    /**
     * Patch Proposition
     *
     * Patch Proposition and returns the patched Proposition.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchProposition<ThrowOnError extends boolean = false>(options: Options<PatchPropositionData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchPropositionResponses, patchPropositionErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/proposition/{propositionID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TierService {
    /**
     * Get list of tiers
     */
    public static listTier<ThrowOnError extends boolean = false>(options: Options<ListTierData, ThrowOnError>) {
        return (options.client ?? client).get<ListTierResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/subscription/tier', ...options });
    }
    
    /**
     * Create a subscription tier
     *
     * Create a subscription tier. The response contains the newly created tier item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createTier<ThrowOnError extends boolean = false>(options: Options<CreateTierData, ThrowOnError>) {
        return (options.client ?? client).post<CreateTierResponses, createTierErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing subscription tier item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteByIdTier<ThrowOnError extends boolean = false>(options: Options<DeleteByIdTierData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteByIdTierResponses, deleteByIdTierErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier/{tierID}',
            ...options
        });
    }
    
    /**
     * Get tier by ID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdTier<ThrowOnError extends boolean = false>(options: Options<GetByIdTierData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdTierResponses, getByIdTierErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier/{tierID}',
            ...options
        });
    }
    
    /**
     * Patch a Tier
     *
     * Patch a Tier and returns the patched Tier
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchTier<ThrowOnError extends boolean = false>(options: Options<PatchTierData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchTierResponses, patchTierErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier/{tierID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Duplicate tier
     *
     * Duplicate tier. The response contains the newly duplicated tier.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static duplicateTier<ThrowOnError extends boolean = false>(options: Options<DuplicateTierData, ThrowOnError>) {
        return (options.client ?? client).post<DuplicateTierResponses, duplicateTierErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier/duplicate/{originalTierID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TierGroupService {
    /**
     * Get list of tierGroups
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listTierGroup<ThrowOnError extends boolean = false>(options: Options<ListTierGroupData, ThrowOnError>) {
        return (options.client ?? client).get<ListTierGroupResponses, listTierGroupErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier-groups',
            ...options
        });
    }
    
    /**
     * Create tier group
     *
     * Create tier group. The response contains the newly created tier group item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createTierGroup<ThrowOnError extends boolean = false>(options: Options<CreateTierGroupData, ThrowOnError>) {
        return (options.client ?? client).post<CreateTierGroupResponses, createTierGroupErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier-groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get tierGroup by slug or tierSlug
     */
    public static getBySlugTierGroup<ThrowOnError extends boolean = false>(options: Options<GetBySlugTierGroupData, ThrowOnError>) {
        return (options.client ?? client).get<GetBySlugTierGroupResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/subscription/tier-groups/by-slug', ...options });
    }
    
    /**
     * Delete an existing tier group
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteTierGroup<ThrowOnError extends boolean = false>(options: Options<DeleteTierGroupData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteTierGroupResponses, deleteTierGroupErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier-groups/{tierGroupID}',
            ...options
        });
    }
    
    /**
     * Get tier group by ID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdTierGroup<ThrowOnError extends boolean = false>(options: Options<GetByIdTierGroupData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdTierGroupResponses, getByIdTierGroupErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier-groups/{tierGroupID}',
            ...options
        });
    }
    
    /**
     * Patch tier group
     *
     * Patch tier group. The response contains the patched tier group.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchTierGroup<ThrowOnError extends boolean = false>(options: Options<PatchTierGroupData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchTierGroupResponses, patchTierGroupErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier-groups/{tierGroupID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Duplicate tier group
     *
     * Duplicate tier group. The response contains the newly duplicated tier group.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static duplicateTierGroup<ThrowOnError extends boolean = false>(options: Options<DuplicateTierGroupData, ThrowOnError>) {
        return (options.client ?? client).post<DuplicateTierGroupResponses, duplicateTierGroupErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/tier-groups/duplicate/{originalTierGroupID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class UspService {
    /**
     * Create a subscription usp
     *
     * Create a subscription usp. The response contains the newly created usp item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createUsp<ThrowOnError extends boolean = false>(options: Options<CreateUspData, ThrowOnError>) {
        return (options.client ?? client).post<CreateUspResponses, createUspErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/usp/{tierID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an existing subscription usp item
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteByIdusp<ThrowOnError extends boolean = false>(options: Options<DeleteByIduspData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteByIduspResponses, deleteByIduspErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/usp/{uspID}',
            ...options
        });
    }
    
    /**
     * Get usp by ID
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdusp<ThrowOnError extends boolean = false>(options: Options<GetByIduspData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIduspResponses, getByIduspErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/usp/{uspID}',
            ...options
        });
    }
    
    /**
     * Update a subscription usp
     *
     * Update a subscription usp. The response contains the updated usp item.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static updateUsp<ThrowOnError extends boolean = false>(options: Options<UpdateUspData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateUspResponses, updateUspErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/subscription/usp/{uspID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TagTabService {
    /**
     * Deletes tabs for a tag
     *
     * Deletes tabs for a tag and returns 204
     *
     * - Allowed roles: editor, admin
     */
    public static deleteMultipleTagTab<ThrowOnError extends boolean = false>(options: Options<DeleteMultipleTagTabData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteMultipleTagTabResponses, deleteMultipleTagTabErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/tag-tab/{tagID}',
            ...options
        });
    }
    
    /**
     * Get a tag tabs by tagID
     */
    public static listTagTab<ThrowOnError extends boolean = false>(options: Options<ListTagTabData, ThrowOnError>) {
        return (options.client ?? client).get<ListTagTabResponses, unknown, ThrowOnError>({ url: '/edition/{editionID}/tag-tab/{tagID}', ...options });
    }
    
    /**
     * Update tabs for a tag
     *
     * Patch tabs for a tag and respond with the patched tabs.
     *
     * - Allowed roles: editor, admin
     */
    public static patchMultipleTagTab<ThrowOnError extends boolean = false>(options: Options<PatchMultipleTagTabData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchMultipleTagTabResponses, patchMultipleTagTabErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/tag-tab/{tagID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TagTemplateService {
    /**
     * List all tag templates
     *
     * - Allowed roles: editor, admin
     */
    public static listTagTemplate<ThrowOnError extends boolean = false>(options: Options<ListTagTemplateData, ThrowOnError>) {
        return (options.client ?? client).get<ListTagTemplateResponses, listTagTemplateErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/tag-template',
            ...options
        });
    }
    
    /**
     * Get template tabs by tagTemplateID
     *
     * - Allowed roles: editor, admin
     */
    public static listTabsTagTemplate<ThrowOnError extends boolean = false>(options: Options<ListTabsTagTemplateData, ThrowOnError>) {
        return (options.client ?? client).get<ListTabsTagTemplateResponses, listTabsTagTemplateErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/tag-template/{tagTemplateID}/tab',
            ...options
        });
    }
}

export class UserGeneratedContentService {
    /**
     * Create user generated content.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static createUserGeneratedContent<ThrowOnError extends boolean = false>(options: Options<CreateUserGeneratedContentData, ThrowOnError>) {
        return (options.client ?? client).post<CreateUserGeneratedContentResponses, createUserGeneratedContentErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/edition/{editionID}/user-generated-content',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class FileService {
    /**
     * Upload a file.
     *
     * Uploads the file and responds with identifier to later use the file.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static fileUploadFileUpload<ThrowOnError extends boolean = false>(options: Options<FileUploadFileUploadData, ThrowOnError>) {
        return (options.client ?? client).post<FileUploadFileUploadResponses, fileUploadFileUploadErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/file-upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    /**
     * Process image block
     *
     * Processes the url on the image block to save uploaded file
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static processImageBlockFileUpload<ThrowOnError extends boolean = false>(options: Options<ProcessImageBlockFileUploadData, ThrowOnError>) {
        return (options.client ?? client).post<ProcessImageBlockFileUploadResponses, processImageBlockFileUploadErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/file-upload/process-image-block',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CompetitionService {
    /**
     * Get competition
     *
     * Get competition
     */
    public static getCompetition<ThrowOnError extends boolean = false>(options: Options<GetCompetitionData, ThrowOnError>) {
        return (options.client ?? client).get<GetCompetitionResponses, unknown, ThrowOnError>({ url: '/football/competition/by-tag/{id}', ...options });
    }
}

export class PlayerService {
    /**
     * Get player details
     *
     * Get player details
     */
    public static getByIdPlayer<ThrowOnError extends boolean = false>(options: Options<GetByIdPlayerData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdPlayerResponses, unknown, ThrowOnError>({ url: '/football/player/{id}', ...options });
    }
    
    /**
     * Get player career details
     *
     * Get player career details
     */
    public static getCareerByIdPlayer<ThrowOnError extends boolean = false>(options: Options<GetCareerByIdPlayerData, ThrowOnError>) {
        return (options.client ?? client).get<GetCareerByIdPlayerResponses, unknown, ThrowOnError>({ url: '/football/player/{id}/career', ...options });
    }
    
    /**
     * Get player passport details
     *
     * Get player passport details
     */
    public static getPassportByIdPlayer<ThrowOnError extends boolean = false>(options: Options<GetPassportByIdPlayerData, ThrowOnError>) {
        return (options.client ?? client).get<GetPassportByIdPlayerResponses, unknown, ThrowOnError>({ url: '/football/player/{id}/passport', ...options });
    }
}

export class TeamService {
    /**
     * Get all shirts
     *
     * Get all shirts with teamname
     */
    public static getShirtsTeam<ThrowOnError extends boolean = false>(options?: Options<GetShirtsTeamData, ThrowOnError>) {
        return (options?.client ?? client).get<GetShirtsTeamResponses, getShirtsTeamErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/team/shirt',
            ...options
        });
    }
    
    /**
     * Get team selection
     *
     * Get team selection
     */
    public static getTeamSelectionTeam<ThrowOnError extends boolean = false>(options: Options<GetTeamSelectionTeamData, ThrowOnError>) {
        return (options.client ?? client).get<GetTeamSelectionTeamResponses, unknown, ThrowOnError>({ url: '/football/team/{id}/selection', ...options });
    }
    
    /**
     * Get team details
     *
     * Get team details
     */
    public static getByIdTeam<ThrowOnError extends boolean = false>(options: Options<GetByIdTeamData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdTeamResponses, unknown, ThrowOnError>({ url: '/football/team/{id}', ...options });
    }
}

export class TournamentService {
    /**
     * Get tournament standings
     *
     * Get tournament standings
     */
    public static getTournamentStandingsTournament<ThrowOnError extends boolean = false>(options: Options<GetTournamentStandingsTournamentData, ThrowOnError>) {
        return (options.client ?? client).get<GetTournamentStandingsTournamentResponses, unknown, ThrowOnError>({ url: '/football/tournament/{id}/standings', ...options });
    }
    
    /**
     * Get tournament rankings
     *
     * Get tournament rankings
     */
    public static getTournamentRankingsTournament<ThrowOnError extends boolean = false>(options: Options<GetTournamentRankingsTournamentData, ThrowOnError>) {
        return (options.client ?? client).get<GetTournamentRankingsTournamentResponses, unknown, ThrowOnError>({ url: '/football/tournament/{id}/rankings', ...options });
    }
    
    /**
     * Get tournament rounds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getTournamentRoundsTournament<ThrowOnError extends boolean = false>(options: Options<GetTournamentRoundsTournamentData, ThrowOnError>) {
        return (options.client ?? client).get<GetTournamentRoundsTournamentResponses, getTournamentRoundsTournamentErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/tournament/{id}/rounds',
            ...options
        });
    }
}

export class MatchService {
    /**
     * Get matches list for date range
     *
     * Get all matches played in specified dates for competitions, that are configured in the admin system. Use timespan not longer than 7 days.
     */
    public static getForSpecifiedDatesMatch<ThrowOnError extends boolean = false>(options?: Options<GetForSpecifiedDatesMatchData, ThrowOnError>) {
        return (options?.client ?? client).get<GetForSpecifiedDatesMatchResponses, unknown, ThrowOnError>({ url: '/football/match', ...options });
    }
    
    /**
     * Get basic info of a given match
     *
     * Get basic info of a given match
     */
    public static getBySlugMatch<ThrowOnError extends boolean = false>(options: Options<GetBySlugMatchData, ThrowOnError>) {
        return (options.client ?? client).get<GetBySlugMatchResponses, unknown, ThrowOnError>({ url: '/football/match/slug/{kickOffDate}/{slug}', ...options });
    }
    
    /**
     * Get details of a given match
     *
     * Get details of a given match
     */
    public static getMatchDetailsMatch<ThrowOnError extends boolean = false>(options: Options<GetMatchDetailsMatchData, ThrowOnError>) {
        return (options.client ?? client).get<GetMatchDetailsMatchResponses, unknown, ThrowOnError>({ url: '/football/match/{id}/detail', ...options });
    }
    
    /**
     * Get details of a given match
     *
     * Get details of a given match
     */
    public static getMatchDetailsBySlugMatch<ThrowOnError extends boolean = false>(options: Options<GetMatchDetailsBySlugMatchData, ThrowOnError>) {
        return (options.client ?? client).get<GetMatchDetailsBySlugMatchResponses, unknown, ThrowOnError>({ url: '/football/match/slug/{kickOffDate}/{slug}/detail', ...options });
    }
    
    /**
     * Search matches close to the current date (returns max 8 results)
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static searchMatch<ThrowOnError extends boolean = false>(options: Options<SearchMatchData, ThrowOnError>) {
        return (options.client ?? client).get<SearchMatchResponses, searchMatchErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/match/search',
            ...options
        });
    }
    
    /**
     * Get matches list for tournament
     */
    public static getForTournamentMatch<ThrowOnError extends boolean = false>(options: Options<GetForTournamentMatchData, ThrowOnError>) {
        return (options.client ?? client).get<GetForTournamentMatchResponses, unknown, ThrowOnError>({ url: '/football/match/tournament/{tournamentID}', ...options });
    }
    
    /**
     * Get matches list for a competition
     */
    public static getForCompetitionMatch<ThrowOnError extends boolean = false>(options: Options<GetForCompetitionMatchData, ThrowOnError>) {
        return (options.client ?? client).get<GetForCompetitionMatchResponses, unknown, ThrowOnError>({ url: '/football/match/competition/{competitionID}', ...options });
    }
    
    /**
     * Get matches list for team
     */
    public static getForTeamMatch<ThrowOnError extends boolean = false>(options: Options<GetForTeamMatchData, ThrowOnError>) {
        return (options.client ?? client).get<GetForTeamMatchResponses, unknown, ThrowOnError>({ url: '/football/match/team/{teamID}', ...options });
    }
    
    /**
     * Get matches list by Opta IDs
     *
     * Get matches list by Opta IDs
     */
    public static getByIdsMatch<ThrowOnError extends boolean = false>(options?: Options<GetByIdsMatchData, ThrowOnError>) {
        return (options?.client ?? client).get<GetByIdsMatchResponses, unknown, ThrowOnError>({ url: '/football/match/ids', ...options });
    }
    
    /**
     * Get upcoming matches with odds for teams
     *
     * Get upcoming matches with odds based on provided opta ids
     */
    public static getMatchesWithOddsMatch<ThrowOnError extends boolean = false>(options?: Options<GetMatchesWithOddsMatchData, ThrowOnError>) {
        return (options?.client ?? client).get<GetMatchesWithOddsMatchResponses, unknown, ThrowOnError>({ url: '/football/match/with-odds', ...options });
    }
    
    /**
     * Get basic info of a given match
     *
     * Get basic info of a given match
     */
    public static getByIdMatch<ThrowOnError extends boolean = false>(options: Options<GetByIdMatchData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdMatchResponses, unknown, ThrowOnError>({ url: '/football/match/{id}', ...options });
    }
}

export class OptaExportService {
    /**
     * Get team export for the magazine
     *
     * Get team export for the magazine
     */
    public static getTeamExportOptaExport<ThrowOnError extends boolean = false>(options: Options<GetTeamExportOptaExportData, ThrowOnError>) {
        return (options.client ?? client).get<GetTeamExportOptaExportResponses, unknown, ThrowOnError>({ url: '/football/opta-export/team/{id}', ...options });
    }
    
    /**
     * Get standings export
     *
     * Get standings export for the magazine
     *
     * - Allowed roles: editor, admin
     */
    public static getStandingsExportOptaExport<ThrowOnError extends boolean = false>(options: Options<GetStandingsExportOptaExportData, ThrowOnError>) {
        return (options.client ?? client).get<GetStandingsExportOptaExportResponses, getStandingsExportOptaExportErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/opta-export/standings/{id}',
            ...options
        });
    }
    
    /**
     * Get magazine schedule export
     *
     * Get schedule export for the selected competition (x days ahead)
     *
     * - Allowed roles: editor, admin
     */
    public static getScheduleExportOptaExport<ThrowOnError extends boolean = false>(options: Options<GetScheduleExportOptaExportData, ThrowOnError>) {
        return (options.client ?? client).get<GetScheduleExportOptaExportResponses, getScheduleExportOptaExportErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/opta-export/schedule/{id}',
            ...options
        });
    }
    
    /**
     * Get magazine rankings export
     *
     * Get rankings export for the selected tournament
     *
     * - Allowed roles: editor, admin
     */
    public static getRankingExportOptaExport<ThrowOnError extends boolean = false>(options: Options<GetRankingExportOptaExportData, ThrowOnError>) {
        return (options.client ?? client).get<GetRankingExportOptaExportResponses, getRankingExportOptaExportErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/opta-export/rankings/{id}',
            ...options
        });
    }
    
    /**
     * Get magazine rating export
     *
     * Get 'player' ratings export for the selected tournament
     *
     * - Allowed roles: editor, admin
     */
    public static getRatingExportOptaExport<ThrowOnError extends boolean = false>(options: Options<GetRatingExportOptaExportData, ThrowOnError>) {
        return (options.client ?? client).get<GetRatingExportOptaExportResponses, getRatingExportOptaExportErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/opta-export/rating/{id}',
            ...options
        });
    }
    
    /**
     * Get magazine competition matches export
     *
     * Get 'competition matches' export for the selected tournament
     *
     * - Allowed roles: editor, admin
     */
    public static getCompetitionMatchesExportOptaExport<ThrowOnError extends boolean = false>(options: Options<GetCompetitionMatchesExportOptaExportData, ThrowOnError>) {
        return (options.client ?? client).get<GetCompetitionMatchesExportOptaExportResponses, getCompetitionMatchesExportOptaExportErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/opta-export/competition/matches',
            ...options
        });
    }
    
    /**
     * Get magazine national matches export
     *
     * Get 'national matches' export for the selected tournament
     *
     * - Allowed roles: editor, admin
     */
    public static getNationalMatchesExportOptaExport<ThrowOnError extends boolean = false>(options?: Options<GetNationalMatchesExportOptaExportData, ThrowOnError>) {
        return (options?.client ?? client).get<GetNationalMatchesExportOptaExportResponses, getNationalMatchesExportOptaExportErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/opta-export/national/matches',
            ...options
        });
    }
}

export class ImportService {
    /**
     * Import competitions and tournaments from opta
     *
     * Import competitions and tournaments from opta
     *
     * - Allowed roles: app_cron
     */
    public static importTournamentsOptaImport<ThrowOnError extends boolean = false>(options?: Options<ImportTournamentsOptaImportData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportTournamentsOptaImportResponses, importTournamentsOptaImportErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/football/import/tournaments',
            ...options
        });
    }
    
    /**
     * Import teams from opta
     *
     * Import teams from opta
     *
     * - Allowed roles: app_cron
     */
    public static importTeamsOptaImport<ThrowOnError extends boolean = false>(options?: Options<ImportTeamsOptaImportData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportTeamsOptaImportResponses, importTeamsOptaImportErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/football/import/teams',
            ...options
        });
    }
    
    /**
     * Import teams from opta
     *
     * Import teams from opta
     *
     * - Allowed roles: app_cron
     */
    public static importMatchesOptaImport<ThrowOnError extends boolean = false>(options?: Options<ImportMatchesOptaImportData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportMatchesOptaImportResponses, importMatchesOptaImportErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/football/import/matches',
            ...options
        });
    }
    
    /**
     * Fetch events from live matches and push events to listeners
     *
     * - Allowed roles: app_cron
     */
    public static emitMatchEventsOptaImport<ThrowOnError extends boolean = false>(options?: Options<EmitMatchEventsOptaImportData, ThrowOnError>) {
        return (options?.client ?? client).post<EmitMatchEventsOptaImportResponses, emitMatchEventsOptaImportErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/football/import/matches/events',
            ...options
        });
    }
    
    /**
     * Update player tags
     *
     * Fetch all players of the teams in the given team or tournament ID and update ALL player names accordingly
     *
     * - Allowed roles: app_cron
     */
    public static updatePlayerTagsOptaImport<ThrowOnError extends boolean = false>(options: Options<UpdatePlayerTagsOptaImportData, ThrowOnError>) {
        return (options.client ?? client).post<UpdatePlayerTagsOptaImportResponses, updatePlayerTagsOptaImportErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/football/import/update-player-tags/{optaID}',
            ...options
        });
    }
}

export class AiService {
    /**
     * Get all aiResults
     *
     * - Allowed roles: editor, admin
     */
    public static listResultsAi<ThrowOnError extends boolean = false>(options?: Options<ListResultsAiData, ThrowOnError>) {
        return (options?.client ?? client).get<ListResultsAiResponses, listResultsAiErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/ai/result',
            ...options
        });
    }
    
    /**
     * Get the match reports
     *
     * - Allowed roles: editor, admin
     */
    public static matchReportsAi<ThrowOnError extends boolean = false>(options?: Options<MatchReportsAiData, ThrowOnError>) {
        return (options?.client ?? client).get<MatchReportsAiResponses, matchReportsAiErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/ai/match-reports',
            ...options
        });
    }
    
    /**
     * Get the latest generated match reports
     */
    public static latestMatchReportsAi<ThrowOnError extends boolean = false>(options?: Options<LatestMatchReportsAiData, ThrowOnError>) {
        return (options?.client ?? client).get<LatestMatchReportsAiResponses, unknown, ThrowOnError>({ url: '/football/ai/latest-match-reports', ...options });
    }
    
    /**
     * Generate match report for matchID and promptID
     *
     * - Allowed roles: editor, admin
     */
    public static generateMatchReportAi<ThrowOnError extends boolean = false>(options?: Options<GenerateMatchReportAiData, ThrowOnError>) {
        return (options?.client ?? client).get<GenerateMatchReportAiResponses, generateMatchReportAiErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/ai/generate-match-report',
            ...options
        });
    }
    
    /**
     * Import / generate match reports from openAI
     *
     * Import / generate match reports from openAI
     *
     * - Allowed roles: app_cron
     */
    public static generateMatchReportsAi<ThrowOnError extends boolean = false>(options?: Options<GenerateMatchReportsAiData, ThrowOnError>) {
        return (options?.client ?? client).post<GenerateMatchReportsAiResponses, generateMatchReportsAiErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/football/ai/import/reports',
            ...options
        });
    }
}

export class AiPromptService {
    /**
     * Get all aiPrompts
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listAiPrompt<ThrowOnError extends boolean = false>(options?: Options<ListAiPromptData, ThrowOnError>) {
        return (options?.client ?? client).get<ListAiPromptResponses, listAiPromptErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/ai-prompts',
            ...options
        });
    }
    
    /**
     * Create an ai prompt
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createAiPrompt<ThrowOnError extends boolean = false>(options: Options<CreateAiPromptData, ThrowOnError>) {
        return (options.client ?? client).post<CreateAiPromptResponses, createAiPromptErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/ai-prompts/prompt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete aiPrompt.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteAiPrompt<ThrowOnError extends boolean = false>(options: Options<DeleteAiPromptData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteAiPromptResponses, deleteAiPromptErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/ai-prompts/{id}',
            ...options
        });
    }
    
    /**
     * Update an ai prompt
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static updateAiPrompt<ThrowOnError extends boolean = false>(options: Options<UpdateAiPromptData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateAiPromptResponses, updateAiPromptErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/football/ai-prompts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class AuditLogService {
    /**
     * Get audit logs
     *
     * Return a list of audit logs for a contextID.
     *
     * - Allowed roles: admin
     */
    public static listAuditLogByDomainId<ThrowOnError extends boolean = false>(options: Options<ListAuditLogByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListAuditLogByDomainIdResponses, listAuditLogByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/audit-log',
            ...options
        });
    }
}

export class ExperimentService {
    /**
     * Get Experiments
     *
     * Return a list of Experiments for the current context.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listExperimentByDomainId<ThrowOnError extends boolean = false>(options: Options<ListExperimentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListExperimentByDomainIdResponses, listExperimentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/experiment',
            ...options
        });
    }
}

export class FilteredCommentService {
    /**
     * Get filteredComments
     *
     * Return a list of filtered comments for the current context.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listFilteredCommentByDomainId<ThrowOnError extends boolean = false>(options: Options<ListFilteredCommentByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListFilteredCommentByDomainIdResponses, listFilteredCommentByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/filtered-comment',
            ...options
        });
    }
}

export class ForbiddenWordService {
    /**
     * Get all forbidden words
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listForbiddenWordByDomainId<ThrowOnError extends boolean = false>(options: Options<ListForbiddenWordByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListForbiddenWordByDomainIdResponses, listForbiddenWordByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/forbidden-word',
            ...options
        });
    }
    
    /**
     * Create a forbidden word
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createForbiddenWordByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateForbiddenWordByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateForbiddenWordByDomainIdResponses, createForbiddenWordByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/forbidden-word',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete a forbidden word
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteForbiddenWordByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteForbiddenWordByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteForbiddenWordByDomainIdResponses, deleteForbiddenWordByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/forbidden-word/{id}',
            ...options
        });
    }
    
    /**
     * Get a forbidden word
     *
     * Returns a single forbidden word
     */
    public static getForbiddenWordByDomainId<ThrowOnError extends boolean = false>(options: Options<GetForbiddenWordByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetForbiddenWordByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/forbidden-word/{id}', ...options });
    }
    
    /**
     * Update a forbidden word
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static updateForbiddenWordByDomainId<ThrowOnError extends boolean = false>(options: Options<UpdateForbiddenWordByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).patch<UpdateForbiddenWordByDomainIdResponses, updateForbiddenWordByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/forbidden-word/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class RedirectService {
    /**
     * Get redirects
     *
     * Return a list of redirects for the current context.
     */
    public static listRedirectByDomainId<ThrowOnError extends boolean = false>(options: Options<ListRedirectByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<ListRedirectByDomainIdResponses, unknown, ThrowOnError>({ url: '/domain/{contextID}/redirect', ...options });
    }
    
    /**
     * Create a redirect
     *
     * Create a redirect and respond with the newly created redirect.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createRedirectByDomainId<ThrowOnError extends boolean = false>(options: Options<CreateRedirectByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).post<CreateRedirectByDomainIdResponses, createRedirectByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/redirect',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Deletes a redirect
     *
     * Deletes and returns 204 or 404 depending if the request succeeds
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static deleteRedirectByDomainId<ThrowOnError extends boolean = false>(options: Options<DeleteRedirectByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteRedirectByDomainIdResponses, deleteRedirectByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/redirect/{id}',
            ...options
        });
    }
    
    /**
     * Get a redirect
     *
     * Returns a single redirect
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getRedirectByDomainId<ThrowOnError extends boolean = false>(options: Options<GetRedirectByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).get<GetRedirectByDomainIdResponses, getRedirectByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/redirect/{id}',
            ...options
        });
    }
    
    /**
     * Update a redirect
     *
     * Update a redirect and respond with the updated redirect.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static putRedirectByDomainId<ThrowOnError extends boolean = false>(options: Options<PutRedirectByDomainIdData, ThrowOnError>) {
        return (options.client ?? client).put<PutRedirectByDomainIdResponses, putRedirectByDomainIdErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/domain/{contextID}/redirect/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class UserService {
    /**
     * Get a list of ignored userIDs.
     *
     * Return a list of ignored userIDs, filtered by the authenticated user.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static listIgnoredUser<ThrowOnError extends boolean = false>(options?: Options<ListIgnoredUserData, ThrowOnError>) {
        return (options?.client ?? client).get<ListIgnoredUserResponses, listIgnoredUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/ignore',
            ...options
        });
    }
    
    /**
     * Ignore multiple users by userIDs.
     *
     * Add multiple userIDs to the list of ignored users.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static addIgnoredUser<ThrowOnError extends boolean = false>(options: Options<AddIgnoredUserData, ThrowOnError>) {
        return (options.client ?? client).patch<AddIgnoredUserResponses, addIgnoredUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/ignore',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an ignored user by userID
     *
     * Delete a userID from the list of ignored users.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteIgnoredUser<ThrowOnError extends boolean = false>(options: Options<DeleteIgnoredUserData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteIgnoredUserResponses, deleteIgnoredUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/ignore/{userID}',
            ...options
        });
    }
    
    /**
     * Get user list
     *
     * Get a list of all users
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listUser<ThrowOnError extends boolean = false>(options?: Options<ListUserData, ThrowOnError>) {
        return (options?.client ?? client).get<ListUserResponses, listUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user',
            ...options
        });
    }
    
    /**
     * Get user-author by slug.
     *
     * Get user-author by slug.
     */
    public static getAuthorByCustomSlugUser<ThrowOnError extends boolean = false>(options: Options<GetAuthorByCustomSlugUserData, ThrowOnError>) {
        return (options.client ?? client).get<GetAuthorByCustomSlugUserResponses, unknown, ThrowOnError>({ url: '/user/author/{slug}', ...options });
    }
    
    /**
     * Get all authors
     *
     * Get all authors filtered by order
     */
    public static listAuthorsUser<ThrowOnError extends boolean = false>(options: Options<ListAuthorsUserData, ThrowOnError>) {
        return (options.client ?? client).get<ListAuthorsUserResponses, unknown, ThrowOnError>({ url: '/user/authors', ...options });
    }
    
    /**
     * Delete the current user's profile
     *
     * Deletes and returns 204, 403 or 404 depending if the request succeeds.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static deleteProfileUser<ThrowOnError extends boolean = false>(options: Options<DeleteProfileUserData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteProfileUserResponses, deleteProfileUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/profile',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get user profile
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static getProfileByIdUser<ThrowOnError extends boolean = false>(options?: Options<GetProfileByIdUserData, ThrowOnError>) {
        return (options?.client ?? client).get<GetProfileByIdUserResponses, getProfileByIdUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/profile',
            ...options
        });
    }
    
    /**
     * Update personal profile data
     *
     * Update personal profile information. The endpoint might set a new access token.
     *
     * The `AccessTokenPayload` is added to the access token. Compare the `hash` with the `User.accessTokenHash` when fetching the user profile. If they differ, then the AccessTokenPayload is outdated and the access token should be refreshed.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static patchProfileUser<ThrowOnError extends boolean = false>(options: Options<PatchProfileUserData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchProfileUserResponses, patchProfileUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/profile',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get extra user data
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static getExtraInfoUser<ThrowOnError extends boolean = false>(options?: Options<GetExtraInfoUserData, ThrowOnError>) {
        return (options?.client ?? client).get<GetExtraInfoUserResponses, getExtraInfoUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/extra-info',
            ...options
        });
    }
    
    /**
     * **Deprecated**: Should only be used by dark-admin.
     *
     * Get information to authenticate a user in dark-admin.
     *
     * - Allowed roles: moderator, editor, admin
     *
     * @deprecated
     */
    public static getAdminAccessInfoUser<ThrowOnError extends boolean = false>(options?: Options<GetAdminAccessInfoUserData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAdminAccessInfoUserResponses, getAdminAccessInfoUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/admin-access/info',
            ...options
        });
    }
    
    /**
     * Get all tenants that the logged in user is connected to.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static getUserTenantsUser<ThrowOnError extends boolean = false>(options?: Options<GetUserTenantsUserData, ThrowOnError>) {
        return (options?.client ?? client).get<GetUserTenantsUserResponses, getUserTenantsUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/tenant',
            ...options
        });
    }
    
    /**
     * Disassociate user from a tenant
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static disassociateUserFromTenantUser<ThrowOnError extends boolean = false>(options: Options<DisassociateUserFromTenantUserData, ThrowOnError>) {
        return (options.client ?? client).delete<DisassociateUserFromTenantUserResponses, disassociateUserFromTenantUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/tenant/{tenantID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Associate user with a tenant
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static associateUserWithTenantUser<ThrowOnError extends boolean = false>(options: Options<AssociateUserWithTenantUserData, ThrowOnError>) {
        return (options.client ?? client).post<AssociateUserWithTenantUserResponses, associateUserWithTenantUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/tenant/{tenantID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete a user by ID
     *
     * Deletes and returns 204, 403 or 404 depending if the request succeeds.
     *
     * If this user has an active Supertokens access token, session verification will still succeed until their access token expires. After that, they will be logged out, since the session refresh will fail.
     *
     * - Allowed roles: admin
     */
    public static deleteUser<ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteUserResponses, deleteUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/{userID}',
            ...options
        });
    }
    
    /**
     * Get user by id.
     *
     * Get user by id.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static getByIdUser<ThrowOnError extends boolean = false>(options: Options<GetByIdUserData, ThrowOnError>) {
        return (options.client ?? client).get<GetByIdUserResponses, getByIdUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/{userID}',
            ...options
        });
    }
    
    /**
     * Update entry
     *
     * Update a specific user
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static patchUser<ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>) {
        return (options.client ?? client).patch<PatchUserResponses, patchUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/{userID}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Check if a username exists.
     */
    public static usernameExistsUser<ThrowOnError extends boolean = false>(options: Options<UsernameExistsUserData, ThrowOnError>) {
        return (options.client ?? client).get<UsernameExistsUserResponses, unknown, ThrowOnError>({ url: '/user/username/exists', ...options });
    }
    
    /**
     * Check if an email address is already taken by another user. It removes `.` and characters after `+`  before the comparison in order to catch aliases of existing addresses.
     */
    public static emailExistsUser<ThrowOnError extends boolean = false>(options: Options<EmailExistsUserData, ThrowOnError>) {
        return (options.client ?? client).get<EmailExistsUserResponses, unknown, ThrowOnError>({ url: '/user/email/exists', ...options });
    }
    
    /**
     * Check if email or username exists.
     */
    public static emailOrUsernameExistsUser<ThrowOnError extends boolean = false>(options: Options<EmailOrUsernameExistsUserData, ThrowOnError>) {
        return (options.client ?? client).get<EmailOrUsernameExistsUserResponses, unknown, ThrowOnError>({ url: '/user/email-or-username/exists', ...options });
    }
    
    /**
     * Start the process of changing the email address
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static changeEmailUser<ThrowOnError extends boolean = false>(options: Options<ChangeEmailUserData, ThrowOnError>) {
        return (options.client ?? client).put<ChangeEmailUserResponses, changeEmailUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/profile/email',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update a user's password with a generate password. You can only change the password for a user with one of the following roles: editor, admin.
     *
     * The response contains the generated password. This is the only time you will be able to see the password.
     *
     * - Allowed roles: admin
     */
    public static setGeneratedPasswordUser<ThrowOnError extends boolean = false>(options: Options<SetGeneratedPasswordUserData, ThrowOnError>) {
        return (options.client ?? client).post<SetGeneratedPasswordUserResponses, setGeneratedPasswordUserErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/user/{userID}/set-generated-password',
            ...options
        });
    }
    
    /**
     * Add Supertokens users to all existing users. This should only be called on the staging environment after a production sync.
     *
     * - Allowed roles: app_mysql_env_migration
     */
    public static syncStagingSupertokensUsersUser<ThrowOnError extends boolean = false>(options?: Options<SyncStagingSupertokensUsersUserData, ThrowOnError>) {
        return (options?.client ?? client).post<unknown, syncStagingSupertokensUsersUserErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/user/sync-supertokens-users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    /**
     * Renews zeno status for all users with zenoRenewalStatus `to-do`
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 300000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static renewZenoStatusUser<ThrowOnError extends boolean = false>(options?: Options<RenewZenoStatusUserData, ThrowOnError>) {
        return (options?.client ?? client).post<RenewZenoStatusUserResponses, renewZenoStatusUserErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/user/renew-zeno-status',
            ...options
        });
    }
    
    /**
     * - Allowed roles: app_blueconic
     */
    public static getForThirdPartyUser<ThrowOnError extends boolean = false>(options: Options<GetForThirdPartyUserData, ThrowOnError>) {
        return (options.client ?? client).get<GetForThirdPartyUserResponses, getForThirdPartyUserErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/user/third-party/{userID}',
            ...options
        });
    }
}

export class KambiService {
    /**
     * - Allowed roles: app_cron
     */
    public static syncKambi<ThrowOnError extends boolean = false>(options?: Options<SyncKambiData, ThrowOnError>) {
        return (options?.client ?? client).post<SyncKambiResponses, syncKambiErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/kambi/sync',
            ...options
        });
    }
}

export class LocaleService {
    /**
     * Get a list of locales.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static listLocaleByLocale<ThrowOnError extends boolean = false>(options?: Options<ListLocaleByLocaleData, ThrowOnError>) {
        return (options?.client ?? client).get<ListLocaleByLocaleResponses, listLocaleByLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/locale',
            ...options
        });
    }
}

export class LokaliseService {
    /**
     * Post a missing key to lokalise
     *
     * Using the api to post a key to lokalise
     */
    public static createLokalise<ThrowOnError extends boolean = false>(options: Options<CreateLokaliseData, ThrowOnError>) {
        return (options.client ?? client).post<CreateLokaliseResponses, unknown, ThrowOnError>({
            url: '/lokalise/key',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class MatchOddsService {
    /**
     * - Allowed roles: app_cron
     */
    public static deleteOldMatchOdds<ThrowOnError extends boolean = false>(options?: Options<DeleteOldMatchOddsData, ThrowOnError>) {
        return (options?.client ?? client).delete<DeleteOldMatchOddsResponses, deleteOldMatchOddsErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/match-odds',
            ...options
        });
    }
    
    /**
     * Get matchOdds
     *
     * Return a list of MatchOdds
     */
    public static listMatchOdds<ThrowOnError extends boolean = false>(options?: Options<ListMatchOddsData, ThrowOnError>) {
        return (options?.client ?? client).get<ListMatchOddsResponses, unknown, ThrowOnError>({ url: '/match-odds', ...options });
    }
}

export class MonitoringService {
    /**
     * Get the status of the server.
     *
     * It checks if it can connect to the cache(s) and database(s). If the last successful check was less than a second ago, it immediately returns successfully.
     */
    public static getMonitoring<ThrowOnError extends boolean = false>(options?: Options<GetMonitoringData, ThrowOnError>) {
        return (options?.client ?? client).get<GetMonitoringResponses, unknown, ThrowOnError>({ url: '/monitoring/status', ...options });
    }
    
    /**
     * Get the memory usage of the server.
     */
    public static getMemoryUsageMonitoring<ThrowOnError extends boolean = false>(options?: Options<GetMemoryUsageMonitoringData, ThrowOnError>) {
        return (options?.client ?? client).get<GetMemoryUsageMonitoringResponses, unknown, ThrowOnError>({ url: '/monitoring/memory', ...options });
    }
    
    /**
     * Get the memory snapshot of the api.
     *
     * - Allowed roles: admin
     */
    public static getMemorySnapshotMonitoring<ThrowOnError extends boolean = false>(options?: Options<GetMemorySnapshotMonitoringData, ThrowOnError>) {
        return (options?.client ?? client).get<GetMemorySnapshotMonitoringResponses, getMemorySnapshotMonitoringErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/monitoring/memory-snapshot',
            ...options
        });
    }
}

export class PlatformControllerService {
    /**
     * Get platform by id.
     */
    public static getPlatformByPlatform<ThrowOnError extends boolean = false>(options: Options<GetPlatformByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<GetPlatformByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}', ...options });
    }
    
    /**
     * Get contexts for a contextID.
     */
    public static getContextsPlatformByPlatform<ThrowOnError extends boolean = false>(options: Options<GetContextsPlatformByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<GetContextsPlatformByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/contexts', ...options });
    }
}

export class AdsTxtService {
    /**
     * Get /ads.txt file.
     *
     * Get the contents of the /ads.txt file for a certain platform.
     */
    public static getAdsTxtByPlatform<ThrowOnError extends boolean = false>(options: Options<GetAdsTxtByPlatformData, ThrowOnError>) {
        return (options.client ?? client).get<GetAdsTxtByPlatformResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/ads-txt', ...options });
    }
    
    /**
     * Create or update /ads.txt file.
     *
     * Create or update the contents of the /ads.txt file for a certain platform.
     *
     * - Allowed roles: editor, admin
     */
    public static upsertAdsTxtByPlatform<ThrowOnError extends boolean = false>(options: Options<UpsertAdsTxtByPlatformData, ThrowOnError>) {
        return (options.client ?? client).put<UpsertAdsTxtByPlatformResponses, upsertAdsTxtByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/ads-txt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class WebpService {
    /**
     * - Allowed roles: editor, admin
     */
    public static warmUpCacheWebpByPlatform<ThrowOnError extends boolean = false>(options: Options<WarmUpCacheWebpByPlatformData, ThrowOnError>) {
        return (options.client ?? client).post<unknown, warmUpCacheWebpByPlatformErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/webp/warm-up-cache',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class OddsDossierService {
    /**
     * Get odds dossier data
     *
     * Get odds dossier data for a platform and a locale
     */
    public static getOddsDossierByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<GetOddsDossierByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).get<GetOddsDossierByPlatformLocaleResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/locale/{locale}/odds-dossier', ...options });
    }
    
    /**
     * Create or update the odds dossier data
     *
     * If an odds dossier already exists for the given platform and locale, the API updates the existing one. If it doesn't already exists a new one will be created. Fallback url's and fallback title from news are not set in returned object.
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static upsertOddsDossierByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<UpsertOddsDossierByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).put<UpsertOddsDossierByPlatformLocaleResponses, upsertOddsDossierByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/odds-dossier',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ConfigService {
    /**
     * Get config key by platform
     *
     * Return a config item for a given platform
     */
    public static getConfigByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<GetConfigByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).get<GetConfigByPlatformLocaleResponses, unknown, ThrowOnError>({ url: '/platform/{platform}/locale/{locale}/config', ...options });
    }
    
    /**
     * Create or update config key
     *
     * If an config key already exists for the given platform, the API updates the existing one. If it doesn't already exists a new one will be created.
     *
     * - Allowed roles: admin
     */
    public static upsertConfigByPlatformLocale<ThrowOnError extends boolean = false>(options: Options<UpsertConfigByPlatformLocaleData, ThrowOnError>) {
        return (options.client ?? client).put<UpsertConfigByPlatformLocaleResponses, upsertConfigByPlatformLocaleErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/platform/{platform}/locale/{locale}/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SecureService {
    /**
     * Sign in using email+password or username+password.
     *
     * The `front-token` header contains the base64 encoded front token.
     *
     * The `st-auth-mode` header is set automatically by the client Supertokens SDKs to `cookie` for the web client and `header` for mobile clients, so that the `sAccessToken` and `sRefreshToken` will be sent back to the client in the right way. For more information see <https://supertokens.com/docs/session/common-customizations/sessions/cookie-consent#information-about-our-session-cookies> and <https://supertokens.com/docs/emailpassword/common-customizations/sessions/token-transfer-method>.
     *
     * The `AccessTokenPayload` is added to the access token. Compare the `hash` with the `User.accessTokenHash` when fetching the user profile. If they differ, then the AccessTokenPayload is outdated and the access token should be refreshed.
     */
    public static signInPasswordSecure<ThrowOnError extends boolean = false>(options: Options<SignInPasswordSecureData, ThrowOnError>) {
        return (options.client ?? client).post<SignInPasswordSecureResponses, signInPasswordSecureErrors, ThrowOnError>({
            url: '/secure/sign-in-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Link account to a new tenant and sign in using email+password or username+password.
     *
     * The `front-token` header contains the base64 encoded front token.
     *
     * The `st-auth-mode` header is set automatically by the client Supertokens SDKs to `cookie` for the web client and `header` for mobile clients, so that the `sAccessToken` and `sRefreshToken` will be sent back to the client in the right way. For more information see <https://supertokens.com/docs/session/common-customizations/sessions/cookie-consent#information-about-our-session-cookies> and <https://supertokens.com/docs/emailpassword/common-customizations/sessions/token-transfer-method>.
     *
     * The `AccessTokenPayload` is added to the access token. Compare the `hash` with the `User.accessTokenHash` when fetching the user profile. If they differ, then the AccessTokenPayload is outdated and the access token should be refreshed.
     */
    public static linkAndSignInPasswordSecure<ThrowOnError extends boolean = false>(options: Options<LinkAndSignInPasswordSecureData, ThrowOnError>) {
        return (options.client ?? client).post<LinkAndSignInPasswordSecureResponses, linkAndSignInPasswordSecureErrors, ThrowOnError>({
            url: '/secure/link-and-sign-in-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Sign up with email, username and password.
     *
     * The `front-token` header contains the base64 encoded front token.
     *
     * The `st-auth-mode` header is set automatically by the client Supertokens SDKs to `cookie` for the web client and `header` for mobile clients, so that the `sAccessToken` and `sRefreshToken` will be sent back to the client in the right way. For more information see <https://supertokens.com/docs/session/common-customizations/sessions/cookie-consent#information-about-our-session-cookies> and <https://supertokens.com/docs/emailpassword/common-customizations/sessions/token-transfer-method>.
     *
     * The `AccessTokenPayload` is added to the access token. Compare the `hash` with the `User.accessTokenHash` when fetching the user profile. If they differ, then the AccessTokenPayload is outdated and the access token should be refreshed.
     */
    public static signUpPasswordSecure<ThrowOnError extends boolean = false>(options: Options<SignUpPasswordSecureData, ThrowOnError>) {
        return (options.client ?? client).post<SignUpPasswordSecureResponses, signUpPasswordSecureErrors, ThrowOnError>({
            url: '/secure/sign-up-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * After a production->staging sync, `supertokensID` is set to `NULL` when redacting the users, however the Supertokens database is left the same. This endpoint deletes Supertokens users that are no longer linked to a Next user.
     *
     * - Allowed roles: admin
     */
    public static deleteSupertokensUsersNotLinkedToNextUserSecure<ThrowOnError extends boolean = false>(options?: Options<DeleteSupertokensUsersNotLinkedToNextUserSecureData, ThrowOnError>) {
        return (options?.client ?? client).delete<DeleteSupertokensUsersNotLinkedToNextUserSecureResponses, deleteSupertokensUsersNotLinkedToNextUserSecureErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/secure/supertokens-users-not-linked-to-next-user',
            ...options
        });
    }
    
    /**
     * Send a verification email to the user
     */
    public static sendVerificationEmailSecure<ThrowOnError extends boolean = false>(options: Options<SendVerificationEmailSecureData, ThrowOnError>) {
        return (options.client ?? client).post<SendVerificationEmailSecureResponses, unknown, ThrowOnError>({ url: '/secure/send-verification-email', ...options });
    }
    
    /**
     * Verify the email with the token the user received
     *
     * The `AccessTokenPayload` is added to the access token. Compare the `hash` with the `User.accessTokenHash` when fetching the user profile. If they differ, then the AccessTokenPayload is outdated and the access token should be refreshed.
     */
    public static verifyEmailSecure<ThrowOnError extends boolean = false>(options: Options<VerifyEmailSecureData, ThrowOnError>) {
        return (options.client ?? client).post<VerifyEmailSecureResponses, verifyEmailSecureErrors, ThrowOnError>({
            url: '/secure/verify-email',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verify the new email address with the token the user received
     */
    public static verifyChangedEmailSecure<ThrowOnError extends boolean = false>(options: Options<VerifyChangedEmailSecureData, ThrowOnError>) {
        return (options.client ?? client).post<VerifyChangedEmailSecureResponses, verifyChangedEmailSecureErrors, ThrowOnError>({
            url: '/secure/verify-changed-email',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Send an email with a link to reset the user's password.
     *
     * Status code 403 is returned with `message: 'PASSWORD_MUST_BE_SET_BY_ADMIN'` when this endpoint is called by a user with one of the following roles: editor, admin. Such a user should request an administrator to reset their password using the [set generated password endpoint](#/User/setGeneratedPasswordUser).
     */
    public static sendPasswordResetEmailSecure<ThrowOnError extends boolean = false>(options: Options<SendPasswordResetEmailSecureData, ThrowOnError>) {
        return (options.client ?? client).post<SendPasswordResetEmailSecureResponses, sendPasswordResetEmailSecureErrors, ThrowOnError>({
            url: '/secure/send-password-reset-email',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reset password
     */
    public static resetPasswordSecure<ThrowOnError extends boolean = false>(options: Options<ResetPasswordSecureData, ThrowOnError>) {
        return (options.client ?? client).post<ResetPasswordSecureResponses, resetPasswordSecureErrors, ThrowOnError>({
            url: '/secure/reset-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Update your own password.
     *
     * - Allowed roles: user, moderator, editor, admin
     */
    public static updatePasswordSecure<ThrowOnError extends boolean = false>(options: Options<UpdatePasswordSecureData, ThrowOnError>) {
        return (options.client ?? client).post<UpdatePasswordSecureResponses, updatePasswordSecureErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/secure/update-password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * This endpoint always returns 403. It only exists to add the AccessTokenPayload to the OpenAPI Specification.
     *
     * @deprecated
     */
    public static getAccessTokenPayloadSecure<ThrowOnError extends boolean = false>(options?: Options<GetAccessTokenPayloadSecureData, ThrowOnError>) {
        return (options?.client ?? client).get<GetAccessTokenPayloadSecureResponses, getAccessTokenPayloadSecureErrors, ThrowOnError>({ url: '/secure/access-token-payload', ...options });
    }
}

export class StatusService {
    /**
     * Get the status of the server.
     *
     * It checks if it can connect to the cache(s) and database(s). If the last successful check was less than a second ago, it immediately returns successfully.
     */
    public static getStatus<ThrowOnError extends boolean = false>(options?: Options<GetStatusData, ThrowOnError>) {
        return (options?.client ?? client).get<GetStatusResponses, unknown, ThrowOnError>({ url: '/status', ...options });
    }
}

export class TestEventControllerService {
    /**
     * Publish event
     *
     * Publish event to Redis to simulate live events. Endpoint should be used only for testing purposes
     *
     * - Allowed roles: moderator, editor, admin
     */
    public static createTestEvent<ThrowOnError extends boolean = false>(options: Options<CreateTestEventData, ThrowOnError>) {
        return (options.client ?? client).post<CreateTestEventResponses, createTestEventErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/test/publishEvent',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TotoService {
    /**
     * - Allowed roles: app_cron
     */
    public static syncToto<ThrowOnError extends boolean = false>(options?: Options<SyncTotoData, ThrowOnError>) {
        return (options?.client ?? client).post<SyncTotoResponses, syncTotoErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/toto/sync',
            ...options
        });
    }
    
    /**
     * - Allowed roles: app_cron
     */
    public static importOddsToto<ThrowOnError extends boolean = false>(options?: Options<ImportOddsTotoData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportOddsTotoResponses, importOddsTotoErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/toto/import/odds',
            ...options
        });
    }
}

export class UnibetService {
    /**
     * - Allowed roles: app_cron
     */
    public static importOddsUnibet<ThrowOnError extends boolean = false>(options?: Options<ImportOddsUnibetData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportOddsUnibetResponses, importOddsUnibetErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/unibet/import/odds',
            ...options
        });
    }
}

export class ViMigrationService {
    /**
     * Import VI article based on UUID
     *
     * Attempt to import a VI article based on UUID and provided options
     *
     * - Allowed roles: admin
     */
    public static importViArticleViMigration<ThrowOnError extends boolean = false>(options: Options<ImportViArticleViMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ImportViArticleViMigrationResponses, importViArticleViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/import/{uuid}',
            ...options
        });
    }
    
    /**
     * Create Supertokens users for the newly created VI authors. This should be run after all articles and authors have already been imported.
     *
     * - Allowed roles: admin
     */
    public static createSupertokensUsersViMigration<ThrowOnError extends boolean = false>(options?: Options<CreateSupertokensUsersViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<CreateSupertokensUsersViMigrationResponses, createSupertokensUsersViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/link-authors-to-supertokens',
            ...options
        });
    }
    
    /**
     * CRON Endpoint: Schedule recent news as to-do in migration table
     *
     * - Allowed roles: app_cron
     */
    public static scheduleRecentViMigration<ThrowOnError extends boolean = false>(options?: Options<ScheduleRecentViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ScheduleRecentViMigrationResponses, scheduleRecentViMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/vi-migration/schedule-recent',
            ...options
        });
    }
    
    /**
     * CRON Endpoint: Run the next scheduled article migration
     *
     * Endpoint to run the next scheduled article (oldest with status to-do)
     *
     * - Allowed roles: app_cron
     */
    public static nextViMigration<ThrowOnError extends boolean = false>(options?: Options<NextViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<NextViMigrationResponses, nextViMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/vi-migration/next',
            ...options
        });
    }
    
    /**
     * Schedule news items
     *
     * Schedule news items, starting at the oldest found in migration table and runs until it finds an article in the viMigrationTable or there aren't any left
     *
     * - Allowed roles: admin
     */
    public static scheduleAllViMigration<ThrowOnError extends boolean = false>(options?: Options<ScheduleAllViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ScheduleAllViMigrationResponses, scheduleAllViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/schedule-all',
            ...options
        });
    }
    
    /**
     * Import a VI user.
     *
     * - Allowed roles: app_cron
     */
    public static importUserViMigration<ThrowOnError extends boolean = false>(options: Options<ImportUserViMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ImportUserViMigrationResponses, importUserViMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/vi-migration/import-user/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Import multiple VI users.
     *
     * This endpoint cannot be run concurrently with the same path parameters and query parameters. During the request, for a maximum duration of 60000 milliseconds, all concurrent requests will get status code 429: Too Many Requests.
     *
     * - Allowed roles: app_cron
     */
    public static importUsersBatchViMigration<ThrowOnError extends boolean = false>(options: Options<ImportUsersBatchViMigrationData, ThrowOnError>) {
        return (options.client ?? client).post<ImportUsersBatchViMigrationResponses, importUsersBatchViMigrationErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/vi-migration/import-users',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * ONLY RUN THIS ENDPOINT AFTER YOU'RE DONE WITH THE USER IMPORT.
     *
     * Go through the viUserMigration entries with status != 'completed'. For every entry, if the Next user doesn't exist but the Supertokens user does exist, then delete the Supertokens user. Also, if the Next user doesn't exist, delete the entry from the viUserMigration table, regardless of whether the Supertokens user exists.
     *
     * - Allowed roles: admin
     */
    public static deleteCorruptedUsersViMigration<ThrowOnError extends boolean = false>(options: Options<DeleteCorruptedUsersViMigrationData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCorruptedUsersViMigrationResponses, deleteCorruptedUsersViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/delete-corrupted-users',
            ...options
        });
    }
    
    /**
     * Prepare Viafoura comments
     *
     * - Allowed roles: admin
     */
    public static prepareViafouraCommentsViMigration<ThrowOnError extends boolean = false>(options?: Options<PrepareViafouraCommentsViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<PrepareViafouraCommentsViMigrationResponses, prepareViafouraCommentsViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/prepare-viafoura-comments',
            ...options
        });
    }
    
    /**
     * Import Viafoura comments
     *
     * - Allowed roles: admin
     */
    public static importViafouraCommentsViMigration<ThrowOnError extends boolean = false>(options?: Options<ImportViafouraCommentsViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportViafouraCommentsViMigrationResponses, importViafouraCommentsViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/migrate-viafoura-comments',
            ...options
        });
    }
    
    /**
     * Import VI bookmarks
     *
     * - Allowed roles: admin
     */
    public static importViBookmarksViMigration<ThrowOnError extends boolean = false>(options?: Options<ImportViBookmarksViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ImportViBookmarksViMigrationResponses, importViBookmarksViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/import-bookmarks',
            ...options
        });
    }
    
    /**
     * Merge Next and VI tags
     *
     * - Allowed roles: admin
     */
    public static mergeOptaTagsViMigration<ThrowOnError extends boolean = false>(options?: Options<MergeOptaTagsViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<unknown, mergeOptaTagsViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/merge-opta-tags',
            ...options
        });
    }
    
    /**
     * Replace vi:// links in articles with our cool links.
     *
     * - Allowed roles: admin
     */
    public static replaceLinksViMigration<ThrowOnError extends boolean = false>(options?: Options<ReplaceLinksViMigrationData, ThrowOnError>) {
        return (options?.client ?? client).post<ReplaceLinksViMigrationResponses, replaceLinksViMigrationErrors, ThrowOnError>({
            security: [{
                    in: 'cookie',
                    name: 'sAccessToken',
                    type: 'apiKey'
                }],
            url: '/vi-migration/replace-links',
            ...options
        });
    }
}

export class GeoBlockService {
    /**
     * Geo Block
     *
     * Returns true if the users ip address is valid and from the Netherlands
     */
    public static getGeoBlock<ThrowOnError extends boolean = false>(options?: Options<GetGeoBlockData, ThrowOnError>) {
        return (options?.client ?? client).get<GetGeoBlockResponses, unknown, ThrowOnError>({ url: '/geoBlock', ...options });
    }
}

export class WebsubService {
    /**
     * Endpoint to use as a websub hub
     *
     * Documentation: https://www.w3.org/TR/websub/
     * Testing tool: https://websub.rocks
     */
    public static hubWebSub<ThrowOnError extends boolean = false>(options: Options<HubWebSubData, ThrowOnError>) {
        return (options.client ?? client).post<HubWebSubResponses, unknown, ThrowOnError>({
            ...urlSearchParamsBodySerializer,
            url: '/websub/hub',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options.headers
            }
        });
    }
    
    /**
     * Checks if there is any article to publish, then pushes it to the subscribers
     *
     * - Allowed roles: app_cron
     */
    public static publishIfNeededWebSub<ThrowOnError extends boolean = false>(options?: Options<PublishIfNeededWebSubData, ThrowOnError>) {
        return (options?.client ?? client).post<PublishIfNeededWebSubResponses, publishIfNeededWebSubErrors, ThrowOnError>({
            security: [{ name: 'auth-app-name', type: 'apiKey' }, { name: 'auth-app-password', type: 'apiKey' }],
            url: '/websub/publish-if-needed',
            ...options
        });
    }
}
